import { _ as H, a as O, F as oe, b as ce, c as re } from "./Checkbox.vue_vue_type_script_setup_true_lang-DfApYxlV.js";
import { d as Na } from "./Checkbox.vue_vue_type_script_setup_true_lang-DfApYxlV.js";
import { defineComponent as g, h as m, computed as u, ref as y, provide as J, onMounted as L, inject as ee, watch as N, onBeforeUnmount as Ce, openBlock as s, createElementBlock as c, normalizeClass as z, createElementVNode as w, Fragment as B, toDisplayString as E, createVNode as $, createTextVNode as Q, createCommentVNode as D, useSlots as Re, normalizeStyle as q, createBlock as Z, renderSlot as K, createStaticVNode as b, onBeforeMount as Ee, Transition as Ve, withCtx as j, resolveDynamicComponent as Be, reactive as ie, renderList as U, watchEffect as He, onUnmounted as $e, nextTick as Fe, unref as F } from "vue";
const Ue = g({
  name: "Card",
  setup: (l, { slots: e }) => () => m(
    "div",
    {
      class: "w-full p-5 tablet-h:px-[30px] bg-white rounded-xl border border-[#E5E5E5]"
    },
    e.default?.()
  )
}), qe = g({
  name: "CardTitle",
  props: {
    icon: {
      type: String
    },
    color: {
      type: String,
      default: "#2D2D2D"
    }
  },
  setup(l, { slots: e }) {
    const t = u(
      () => l.color === "#FFFFFF" ? "border-white/15" : "border-gray-200/75"
    );
    return () => m(
      "div",
      {
        class: `flex items-center pb-5 mb-4 border-b ${t.value}`
      },
      [
        l.icon && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        m(H, {
          size: 20,
          name: l.icon,
          class: "mr-2",
          style: `stroke:${l.color}`
        }),
        m(
          "div",
          {
            class: "w-full font-primary font-medium text-[16px] leading-[18px]",
            style: `color:${l.color}`
          },
          e.default?.()
        )
      ]
    );
  }
}), Te = g({
  name: "CardContent",
  setup: (l, { slots: e }) => () => m(
    "div",
    {
      class: "font-secondary text-gray-800 text-[14px] leading-[18px]"
    },
    e.default?.()
  )
}), We = g({
  name: "CardSeparator",
  setup: () => () => m("div", {
    class: "my-[22px] w-full h-px bg-gray-200/75"
  })
}), he = /* @__PURE__ */ Symbol("TableContext"), G = (l) => {
  const e = ee(he, null);
  if (e === null)
    throw new Error(`<${l}> is missing parent <Table /> component`);
  return e;
}, pe = 0.1, A = y({
  //scrollLeft: 0,
  selectedRows: {},
  allSelected: {},
  indeterminate: {}
}), de = (l, e) => {
  const t = A.value.selectedRows[l];
  if (!t) return;
  const i = t[e];
  (A.value.selectedRows[l] || {})[e] = !i;
  const a = new Set(Object.values(t));
  A.value.indeterminate[l] = a.size === 2, a.size === 1 && (A.value.allSelected[l] = Array.from(a)[0]);
}, Le = (l) => {
  const e = u(() => {
    const a = A.value.selectedRows[l];
    return a ? Object.keys(a).filter(i) : [];
  }), t = () => {
    A.value.indeterminate[l] = !1, A.value.allSelected[l] = !1, Object.keys(A.value.selectedRows[l] || {}).forEach((a) => {
      (A.value.selectedRows[l] || {})[a] = !1;
    });
  }, i = (a) => A.value.selectedRows[l]?.[a];
  return {
    toggleRow: (a) => de(l, a),
    selectedRows: e,
    resetSelection: t,
    isRowSelected: i
  };
}, ve = (l, e, t) => {
  l.stopPropagation(), de(e, t);
}, je = g({
  name: "Table",
  props: {
    id: {
      type: String,
      default: crypto.randomUUID()
    },
    autoColumns: {
      type: Boolean,
      default: !0
    }
  },
  setup(l, { slots: e }) {
    return A.value.selectedRows[l.id] = {}, J(he, {
      id: l.id,
      columnSize: y({}),
      autoAdjustColumnSize: y(l.autoColumns)
    }), () => m("div", e.default?.());
  }
}), Oe = g({
  name: "HeaderCheckbox",
  setup(l, { slots: e }) {
    const t = G("HeaderCheckbox"), i = () => {
      if (!Object.keys(A.value.selectedRows).length) return;
      A.value.indeterminate[t.id] = !1;
      const a = new Set(Object.values(A.value.selectedRows[t.id] || {}));
      let o = !0;
      a.size === 1 && Array.from(a)[0] && (o = !1), A.value.allSelected[t.id] = o, Object.keys(A.value.selectedRows[t.id] || {}).forEach((p) => {
        (A.value.selectedRows[t.id] || {})[p] = o;
      });
    };
    return () => m(
      "div",
      {
        class: "min-w-8 max-w-8 h-10 flex items-center justify-start border-b border-gray-800/8"
      },
      m(
        "div",
        { class: "w-fit h-fit", onClick: i },
        e.default?.({
          checked: A.value.allSelected[t.id],
          indeterminate: A.value.indeterminate[t.id]
        })
      )
    );
  }
}), Ze = g({
  name: "Headers",
  setup(l, { slots: e }) {
    const t = () => {
      let i = 0;
      const a = e.default?.().map((h) => (typeof h.type == "object" && h.type.name?.toLowerCase().includes("checkbox") && (h.props = {
        ...h.props,
        rowId: "header"
      }), typeof h.type == "object" && h.type.name === "Header" && (h.props = {
        ...h.props,
        column: ++i
      }), h)), o = a?.find((h) => h.props?.rowId), p = a?.findIndex((h) => "column" in (h.props || {})), n = a?.[p || 0], r = a?.filter(
        (h, v) => v !== p && !h.props?.rowId
      );
      return n && (n.props = {
        ...n.props,
        primary: !0
      }), [
        o,
        m(
          "div",
          {
            class: "min-w-[200px] flex-1 overflow-hidden first-col"
          },
          n
        ),
        //h(
        //  'div',
        //  {
        //    class: 'flex items-center overflow-hidden scrollbar-hidden whitespace-nowrap',
        //    ref: scrollContainer,
        //  },
        //  remainingCells,
        //),
        r
      ];
    };
    return () => m(
      "div",
      {
        class: "flex items-center"
      },
      t()
    );
  }
}), Ge = g({
  name: "Header",
  props: {
    icon: String
  },
  setup(l, { slots: e, attrs: t }) {
    const i = G("Header"), a = y(), o = t.column, p = y(!1);
    L(() => {
      if (!a.value || t.primary) {
        p.value = !0;
        return;
      }
      let r = a.value.clientWidth;
      if (window.getComputedStyle(a.value).display === "none") {
        const I = a.value.cloneNode(!0);
        I.style.position = "absolute", I.style.right = "-9999px", I.style.display = "block", document.body.append(I), r = I.clientWidth, I.remove();
      }
      const h = r * pe, v = r + h, d = i.columnSize.value[o], _ = d ? Math.max(d, v) : v;
      i.columnSize.value[o] = i.autoAdjustColumnSize.value ? _ : r, p.value = !0;
    });
    const n = u(
      () => p.value && {
        ...!t.primary && i.autoAdjustColumnSize.value && {
          minWidth: `${i.columnSize.value[o]}px`,
          maxWidth: `${i.columnSize.value[o]}px`
        },
        ...!t.primary && !i.autoAdjustColumnSize.value && {
          width: `${i.columnSize.value[o]}px`
        }
      }
    );
    return () => m(
      "div",
      {
        class: "h-10 p-2.5 font-secondary font-medium text-[14px] leading-[18px] text-gray-800 flex items-center border-b border-gray-800/8",
        ref: a,
        style: n.value
      },
      [
        e.default?.(),
        l.icon && m(H, {
          name: l.icon,
          size: 12,
          class: "ml-2 stroke-gray-800"
        })
      ]
    );
  }
}), Ne = g({
  name: "Row",
  props: {
    id: {
      type: String
    }
  },
  setup(l, { slots: e }) {
    const t = G("Row"), i = y(!1), a = u(() => ({
      "flex items-center cursor-pointer": !0,
      "bg-green-200/30": l.id && A.value.selectedRows[t.id]?.[l.id],
      "hover:bg-[#FAFAFA]": !A.value.selectedRows[t.id]?.[l.id || ""]
    })), o = () => {
      let p = 0;
      const n = e.default?.().map((_) => (typeof _.type == "object" && _.type.name?.toLowerCase().includes("checkbox") && (_.props = {
        ..._.props,
        rowId: l.id
      }), typeof _.type == "object" && _.type.name === "Cell" && (_.props = {
        ..._.props,
        column: ++p,
        id: l.id
      }), _)), r = n?.find((_) => "rowId" in (_.props || {})), h = n?.findIndex((_) => "column" in (_.props || {})), v = n?.[h || 0], d = n?.filter(
        (_, I) => I !== h && !("rowId" in (_.props || {}))
      );
      if (v && (v.props = {
        ...v.props,
        primary: !0
      }), r && r.children && l.id) {
        const _ = A.value.selectedRows[t.id];
        if (!_) return;
        i.value = !0, (A.value.selectedRows[t.id] || {})[l.id] = l.id in _ ? _[l.id] : A.value.allSelected[t.id];
      }
      return [
        r,
        m(
          "div",
          {
            class: "min-w-[200px] flex-1 first-col"
          },
          v
        ),
        //h(
        //  'div',
        //  {
        //    class: 'flex items-center overflow-y-scroll scrollbar-hidden',
        //    ref: scrollContainer,
        //  },
        //  remainingCells,
        //),
        d
      ];
    };
    return () => m(
      "div",
      {
        class: a.value,
        onClick: (p) => {
          !i.value || !l.id || ve(p, t.id, l.id);
        }
      },
      o()
    );
  }
}), Qe = g({
  name: "Cell",
  props: {
    icon: String
  },
  setup(l, { slots: e, attrs: t }) {
    const i = G("Cell"), a = y(), o = t.column, p = y(!1);
    L(async () => {
      if (!a.value || t.primary || !i.autoAdjustColumnSize.value) {
        p.value = !0;
        return;
      }
      let v = a.value.clientWidth;
      if (window.getComputedStyle(a.value).display === "none") {
        const f = a.value.cloneNode(!0);
        f.style.position = "absolute", f.style.right = "-9999px", f.style.display = "block", document.body.append(f), v = f.clientWidth, f.remove();
      }
      const d = v * pe, _ = i.columnSize.value[o], x = _ < v ? v + d : v, C = _ ? Math.max(_, x) : x;
      i.columnSize.value[o] = C, p.value = !0;
    });
    const n = u(
      () => A.value.selectedRows[i.id]?.[t.id || ""]
    ), r = u(() => ({
      "border-gray-800/[8%]": !n.value,
      "border-green-700/[15%]": n.value
    })), h = u(
      () => p.value && {
        ...!t.primary && i.autoAdjustColumnSize.value && {
          minWidth: `${i.columnSize.value[o]}px`,
          maxWidth: `${i.columnSize.value[o]}px`
        },
        ...!t.primary && !i.autoAdjustColumnSize.value && {
          width: `${i.columnSize.value[o]}px`
        }
      }
    );
    return () => m(
      "div",
      {
        class: [
          "h-[64px] tablet-h:h-10 p-2.5 font-secondary text-[14px] leading-[18px] text-gray-800 border-b flex items-center relative",
          r.value
        ],
        ref: a,
        style: h.value
      },
      [
        l.icon && m(H, {
          name: l.icon,
          size: 18,
          class: "mr-2"
        }),
        e.default?.(),
        n.value && m("div", {
          class: "w-full h-px bg-[#D1E4E8] absolute top-[-1px] left-0"
        })
      ]
    );
  }
}), Ke = g({
  name: "CheckboxCell",
  setup(l, { slots: e, attrs: t }) {
    const i = G("CheckboxCell");
    return () => m(
      "div",
      {
        class: "min-w-8 max-w-8 h-[64px] tablet-h:h-10 flex items-center justify-start"
      },
      m(
        "div",
        {
          class: "w-fit h-fit",
          onClick: (a) => t.rowId && ve(a, i.id, t.rowId)
        },
        e.default?.({
          checked: A.value.selectedRows[i.id]?.[t.rowId]
        })
      )
    );
  }
}), ue = g({
  name: "Menu",
  setup(l, { slots: e }) {
    return () => m(
      "div",
      {
        class: "w-[280px] py-2.5 bg-white rounded-md [box-shadow:0_0_8px_#0000001a,0_2px_4px_#00000033] z-100"
      },
      e.default?.()
    );
  }
}), _e = g({
  name: "MenuItem",
  props: {
    icon: {
      type: String
    },
    disabled: {
      type: Boolean
    }
  },
  setup(l, { slots: e }) {
    const t = u(() => ({
      ...l.disabled && {
        opacity: 0.4,
        pointerEvents: "none"
      }
    }));
    return () => m(
      "div",
      {
        class: "w-full h-8 px-[15px] flex items-center font-secondary text-[14px] leading-[18px] text-gray-800 hover:bg-[#F6F6F6] cursor-pointer",
        style: t.value
      },
      [
        l.icon && m(H, {
          size: 18,
          name: l.icon,
          class: `${l.icon !== "Dacr" ? "stroke-gray-800" : ""} mr-3`
        }),
        e.default?.()
      ]
    );
  }
}), Ye = g({
  name: "Separator",
  setup() {
    return () => m("div", {
      class: "w-full my-2 h-[1px] bg-gray-800/10"
    });
  }
}), ge = /* @__PURE__ */ Symbol("ComboboxContext"), te = (l) => {
  const e = ee(ge, null);
  if (e === null)
    throw new Error(`<${l}> is missing parent <Combobox /> component`);
  return e;
};
let fe = -1, le = -1;
const Xe = g({
  name: "Combobox",
  props: ["modelValue"],
  emits: ["update:modelValue"],
  setup(l, { slots: e, emit: t }) {
    const i = {
      inputEl: y(null),
      hideCursor: y(!1),
      items: y([]),
      addItem(a) {
        const o = {
          id: ++fe,
          value: a,
          selected: !1
        };
        i.items.value.push(o), t(
          "update:modelValue",
          i.items.value.map((p) => p.value)
        ), i.focusedResultId.value = -1, le = -1, i.inputEl.value && (i.inputEl.value.value = "", i.inputEl.value.dispatchEvent(new Event("keyup")), i.inputEl.value.focus());
      },
      removeItem(a) {
        i.items.value = i.items.value.filter((o) => o.id !== a), t(
          "update:modelValue",
          i.items.value.map((o) => o.value)
        );
      },
      selectItem(a) {
        i.items.value.forEach((o) => {
          o.selected = o.id === a;
        });
      },
      selectPreviousItem() {
        const a = i.items.value.findIndex((o) => o.id === i.getSelectedItem()?.id);
        a === -1 || !a || i.selectItem(i.items.value[a - 1].id);
      },
      selectNextItem() {
        const a = i.items.value.findIndex((o) => o.id === i.getSelectedItem()?.id);
        a === -1 || a === i.items.value.length - 1 || i.selectItem(i.items.value[a + 1].id);
      },
      getSelectedItem() {
        return i.items.value.find((a) => a.selected);
      },
      clearSelection() {
        i.items.value.forEach((a) => {
          a.selected = !1;
        });
      },
      focusedResultId: y(-1)
    };
    return J(ge, i), () => m(
      "div",
      {
        id: "combobox"
      },
      e.default?.({
        addItem: i.addItem
      })
    );
  }
}), Je = g({
  name: "ComboboxItem",
  setup(l, { slots: e }) {
    const t = te("ComboboxItem"), i = fe;
    return () => m(
      "div",
      {
        onClick() {
          t.selectItem(i), t.inputEl.value?.focus(), t.hideCursor.value = !0;
        }
      },
      e.default?.({
        selected: t.getSelectedItem()?.id === i
      })
    );
  }
}), et = g({
  name: "ComboboxInput",
  props: {
    placeholder: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["change"],
  setup(l, { emit: e }) {
    const t = te("ComboboxInput"), i = (n) => {
      if (t.getSelectedItem() && (n.preventDefault(), t.hideCursor.value = !0), n.key === "Backspace") {
        if (!t.items.value.length || t.inputEl.value?.selectionStart) return;
        if (t.getSelectedItem()) {
          t.removeItem(t.getSelectedItem().id), t.clearSelection(), t.hideCursor.value = !1, t.inputEl.value?.focus();
          return;
        }
        t.selectItem(t.items.value[t.items.value.length - 1].id);
      }
      if (n.key === "ArrowLeft") {
        if (!t.items.value.length || t.inputEl.value?.selectionStart) return;
        t.getSelectedItem() ? t.selectPreviousItem() : (t.selectItem(t.items.value[t.items.value.length - 1].id), t.hideCursor.value = !0);
      }
      if (n.key === "ArrowRight") {
        if (!t.items.value.length || t.inputEl.value?.selectionStart) return;
        t.getSelectedItem().id === t.items.value[t.items.value.length - 1].id ? (t.clearSelection(), t.hideCursor.value = !1) : t.selectNextItem();
      }
      if (n.key === "ArrowDown") {
        t.hideCursor.value = !0;
        const r = Math.min(++t.focusedResultId.value, le);
        if (document.querySelector(`[tabindex="${r}"]`))
          t.focusedResultId.value = r;
        else {
          const h = Math.min(
            ...Array.from(document.querySelectorAll("#combobox div[tabindex]")).map(
              (v) => v.tabIndex
            )
          );
          t.focusedResultId.value = h;
        }
      }
      if (n.key === "ArrowUp") {
        const r = Math.max(--t.focusedResultId.value, 0);
        document.querySelector(`[tabindex="${r}"]`) && (t.focusedResultId.value = r);
      }
    }, a = (n) => {
      const r = n.target.value;
      e("change", r);
    }, o = () => {
      t.clearSelection(), t.hideCursor.value = !1;
    }, p = u(() => ({
      ...(l.disabled || t.hideCursor.value) && {
        "caret-color": "transparent"
      }
    }));
    return () => m("input", {
      placeholder: l.placeholder,
      onKeydown: i,
      onKeyup: a,
      onClick: o,
      ref: t.inputEl,
      style: p.value
    });
  }
}), tt = g({
  name: "ComboboxResult",
  props: ["value"],
  setup(l, { slots: e }) {
    const t = te("ComboboxResult"), i = ++le, a = y();
    N(
      () => t.focusedResultId,
      () => {
        i === t.focusedResultId.value && a.value?.scrollIntoView({
          block: "nearest"
        });
      },
      {
        deep: !0
      }
    );
    const o = () => {
      t.addItem(l.value), t.hideCursor.value = !1;
    }, p = (n) => {
      n.key === "Enter" && i === t.focusedResultId.value && (t.addItem(l.value), t.hideCursor.value = !1);
    };
    return L(() => {
      window.addEventListener("keydown", p);
    }), Ce(() => {
      window.removeEventListener("keydown", p);
    }), () => m(
      "div",
      {
        onClick: o,
        ref: a,
        tabindex: i
      },
      e.default?.({
        focused: i === t.focusedResultId.value
      })
    );
  }
}), ye = /* @__PURE__ */ Symbol("AccordionContext"), lt = (l) => {
  const e = ee(ye, null);
  if (e === null)
    throw new Error(`<${l}> is missing parent <Accordion /> component`);
  return e;
}, at = g({
  name: "Accordion",
  setup(l, { slots: e }) {
    const t = {
      activeItem: y(""),
      changeActiveIndex(i) {
        t.activeItem.value = i;
      }
    };
    return J(ye, t), () => m("div", { class: "w-full h-full flex flex-col" }, e.default?.());
  }
}), it = g({
  name: "AccordionItem",
  props: {
    id: {
      type: String,
      required: !0
    }
  },
  setup(l, { slots: e }) {
    const t = lt("AccordionItem"), i = u(() => l.id === t.activeItem.value);
    return t.activeItem.value || (t.activeItem.value = l.id), () => m(
      "div",
      {
        class: `flex flex-col h-[50px] bg-white z-10 border-t border-[#E5E5E5] transition-all duration-300 ease-[ease] ${i.value && "grow"}`,
        onClick: () => t.changeActiveIndex(l.id)
      },
      e.default?.()
    );
  }
}), nt = g({
  name: "AccordionHeader",
  setup: (l, { slots: e }) => () => m(
    "div",
    {
      class: "w-full px-4 py-[15px] flex items-center font-primary font-bold text-[14px] leading-[20px] cursor-pointer"
    },
    e.default?.()
  )
}), st = g({
  name: "AccordionContent",
  setup(l, { slots: e }) {
    return () => m("div", { class: "px-4 font-primary text-gray-800" }, e.default?.());
  }
}), ot = /* @__PURE__ */ g({
  __name: "Toggle",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    compact: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, i = e, a = u(() => ({
      "bg-green-900": t.modelValue,
      "opacity-40 pointer-events-none": t.modelValue && t.disabled,
      "opacity-50 pointer-events-none": !t.modelValue && t.disabled,
      "min-w-[34px]! max-w-[34px]! h-5!": t.compact
    })), o = u(() => ({
      "translate-x-[22px] tablet-h:translate-x-[14px]": t.modelValue,
      ...t.compact && {
        "size-4!": !0,
        "translate-x-[14px]!": t.modelValue
      }
    })), p = () => i("update:modelValue", !t.modelValue);
    return (n, r) => (s(), c("div", {
      id: "toggle",
      class: z(["min-w-[52px] max-w-[52px] tablet-h:min-w-[34px]! tablet-h:max-w-[34px]! h-[30px] tablet-h:h-5! rounded-2xl cursor-pointer p-0.5 bg-gray-300/40", a.value]),
      onClick: p
    }, [
      w("div", {
        id: "knob",
        class: z(["size-[26px] tablet-h:size-4 rounded-full bg-white", o.value])
      }, null, 2)
    ], 2));
  }
}), za = /* @__PURE__ */ O(ot, [["__scopeId", "data-v-4fd883f8"]]), ct = { class: "relative text-[14px] leading-[18px]" }, rt = ["id", "type", "value", "min", "max", "tabIndex", "enterkeyhint"], ht = ["for"], pt = {
  key: 0,
  class: "flex font-secondary text-[12px] leading-[16px] text-red-500 mt-[5px]"
}, dt = /* @__PURE__ */ g({
  __name: "UiInput",
  props: {
    label: {},
    modelValue: {},
    type: {},
    errorMsg: {},
    min: {},
    max: {},
    disabled: { type: Boolean },
    tabindex: {},
    class: {},
    onSubmit: { type: Function }
  },
  emits: ["update:modelValue", "focus", "submit"],
  setup(l, { emit: e }) {
    const t = l, i = e, a = y(null), o = u(() => t.type || "text"), p = u(() => t.label.toLowerCase().replace(/\W+/g, " ").trim().replace(/\s/g, "-")), n = u(() => t.disabled ? -1 : t.tabindex), r = u(() => ({
      "pointer-events-none bg-gray-200/15! tablet-h:bg-gray-200/10! text-gray-500/40!": t.disabled,
      "border-red-500!": t.errorMsg,
      "tablet-h:focus:outline-solid tablet-h:focus:outline-2 tablet-h:focus:outline-green-200/50 tablet-h:focus:border-green-500": !t.errorMsg,
      ...t.class && t.class.split(" ").reduce(
        (f, V) => (f[V] = !0, f),
        {}
      )
    })), h = u(() => ({
      "peer-placeholder-shown:text-gray-500/40! text-gray-500/30! peer-focus:text-gray-500/30!": t.disabled
    })), v = () => {
      if (t.disabled || t.tabindex === -1) {
        a.value?.blur();
        return;
      }
      a.value?.focus(), i("focus");
    }, d = (f) => {
      i("update:modelValue", f.target.value);
    }, _ = (f) => {
      if (f.key === "." || f.key === ",")
        return t.modelValue.includes(".") || t.modelValue.includes(",") ? f.preventDefault() : !0;
      if (!/^\d+$/.test(f.key) && !["ArrowLeft", "ArrowRight", "Backspace", ".", ","].includes(f.key))
        return f.preventDefault();
    }, I = (f) => {
      if (t.type === "number" && _(f), f.key === "Enter" && n.value && !t.onSubmit) {
        let V = n.value;
        document.querySelector(`input[tabIndex="${++V}"]`)?.focus();
      }
      f.key === "Enter" && n.value && t.onSubmit && (a.value?.blur(), i("submit"));
    }, x = () => {
      if (t.type === "number" && Number(t.modelValue) !== 0 && t.max) {
        const f = Math.min(Number(t.modelValue), t.max || 100);
        i("update:modelValue", f);
      }
    }, C = u(() => {
      if (n.value && t.onSubmit)
        return "done";
      if (n.value && !t.onSubmit)
        return "next";
    });
    return N(
      () => t.disabled,
      () => {
        t.disabled && a.value?.blur();
      }
    ), L(() => {
      const f = setInterval(() => {
        document.querySelector(`#${p.value}:-webkit-autofill`) && (v(), a.value?.blur(), clearInterval(f));
      }, 50);
      setTimeout(() => {
        clearInterval(f);
      }, 1e3);
    }), (f, V) => (s(), c(B, null, [
      w("div", ct, [
        w("input", {
          id: p.value,
          placeholder: " ",
          type: o.value,
          ref_key: "input",
          ref: a,
          class: z(["font-primary peer appearance-none w-full h-[48px] pt-[22px] px-[17px] pb-2 bg-gray-200/25 tablet-h:bg-transparent rounded-md text-gray-800 outline-hidden border border-transparent tablet-h:border-gray-200/75 tablet-h:hover:border-gray-300/50", r.value]),
          value: t.modelValue,
          min: t.min,
          max: t.max,
          tabIndex: n.value,
          enterkeyhint: C.value,
          onFocus: v,
          onInput: d,
          onChange: d,
          onKeydown: I,
          onFocusout: x
        }, null, 42, rt),
        w("label", {
          for: p.value,
          class: z(["font-primary pointer-events-none transition-all text-gray-500/70 absolute left-[18px] top-[5px] origin-[0] peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-2.5 translate-y-0 peer-focus:translate-y-0 peer-placeholder-shown:text-[14px] peer-placeholder-shown:font-[400] font-medium peer-focus:font-medium", h.value])
        }, E(t.label), 11, ht)
      ]),
      t.errorMsg ? (s(), c("div", pt, [
        $(H, {
          size: 14,
          name: "Alert",
          class: "mr-[5px] stroke-red-500 mt-px"
        }),
        Q(" " + E(l.errorMsg), 1)
      ])) : D("", !0)
    ], 64));
  }
}), ka = /* @__PURE__ */ O(dt, [["__scopeId", "data-v-02f4470a"]]), vt = ["src"], ut = {
  key: 1,
  class: "flex items-center"
}, Sa = /* @__PURE__ */ g({
  __name: "UiButton",
  props: {
    primary: { type: Boolean },
    secondary: { type: Boolean },
    danger: { type: Boolean },
    large: { type: Boolean },
    icon: {},
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(l) {
    const e = l, t = Re(), i = y(), a = u(() => !e.primary && !e.danger && !e.secondary), o = u(() => !t.default && e.icon), p = u(() => ({
      "min-h-[40px] max-h-[40px] tablet-h:min-h-[32px]! tablet-h:max-h-[32px]!": !e.large,
      "min-h-12 tablet-h:min-h-10! max-h-12 tablet-h:max-h-10! text-[16px]": e.large,
      "min-w-[70px]": !o.value,
      ...a.value && {
        "border border-gray-200/75 hover:border-gray-300/50 text-gray-800 hover:bg-gray-200/[13%]": !0,
        ...t.default && {
          "pl-[9px] pr-2.5 tablet-h:pl-[11px]": e.icon,
          "px-[11px] tablet-h:px-3": !e.icon
        },
        "px-[11px]": o.value,
        "text-gray-500/40! pointer-events-none": e.disabled || e.loading,
        "font-[450]! tablet-h:font-[410]! px-[15px]": e.large
      },
      ...!a.value && {
        "pl-2.5 tablet-h:pl-[11px]! pr-[11px] tablet-h:pr-3": t.default && e.icon,
        "px-3 tablet-h:px-[13px]": t.default && !e.icon,
        "font-[410]! px-4": e.large,
        "bg-gray-500! opacity-40 pointer-events-none": e.disabled || e.loading
      },
      ...e.primary && {
        "bg-green-900 hover:bg-green-800 text-white": !0
      },
      ...e.secondary && {
        "bg-green-200 hover:bg-green-100 text-green-900": !0
      },
      ...e.danger && {
        "bg-red-700 hover:bg-red-600 text-white": !0
      }
    })), n = u(() => {
      const v = i.value?.offsetWidth;
      return {
        ...e.loading && {
          "min-width": `${v}px`
        }
      };
    }), r = u(() => ({
      ...a.value && {
        "stroke-gray-800": !0,
        "stroke-gray-500! opacity-40": e.disabled || e.loading
      },
      "stroke-white": !a.value,
      "mr-1.5": t.default
    })), h = u(() => a.value ? new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAGxlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAACQAAAAAQAAAJAAAAABAAKgAgAEAAAAAQAAACCgAwAEAAAAAQAAACAAAAAAxqyL9QAAAAlwSFlzAAAWJQAAFiUBSVIk8AAABGxJREFUWAm1l11PY1UUhns++gkdpdAB0fFigoERgjZckLmCH+At/4f4Q/whXpsQTTAKAYFhZtAwSWMbB2qBftBzfN7t2fXQVqyl7GR3f5y91vuud++9zqmTGL64pVJput1ufxSG4RPHcXKdTifneZ5Lv0G/SVu7vb19d3x8XMZtMIxr578WLSwspCcmJhZw/AkAScBdFbWqzLn4cHrmOxB7g93POzs7N/dhePc8dFdWVp4D8AXOp8DUWhFmyjGt7Qucvq165rPkaaPReDE3N+f/TmEupPaVgQosLy+ncLBK/VDOo+hMlFHfKuCxxj63c12FQLPKVFKp1Le7u7vXvQz6FFhdXZ3AaQmgSTwlaE206luHPI8rYLYgmjMq0DetbMUGu0m28LNCofCuWq3e2RI97BZFzmCFqjbkYIU4M1V9LbRj9WPFEkqAp6hNjcCtcnlU+GptbS0Xs0vEFXBnZ2c/B2hCpAEy0eNMTmWjaDSvE34aBMFhsVg8yOVyv9Rqtbc4rwqYom2TX3NA6WtrZCsiGfx/vLGxcXR4ePh3QPKswoF7RvNMi2mtdA5Arq4ahtVMJvNq0D7K3pbFxUVFus74eQQOtrk1ViWR/GF/f39HNppMIEuSPSoB5omAJQGwkY/5twcHB79p7bCF7fwSoJdU4xM7owStCNzC6Zu9vb0ro+319fU8BBJEGfDAVBYFjKXp6/8LLpLY/ISv76WCBWdstoJxivmXWqeHDpIVBBiBCtiQQIEKLM+1cJSC7Y/YvcEv2P8kL+ZcVNVh99z19fW8JKcoxRkSEZEOh+vXUYDjNr7vf6dxTAmTL8BKc+U/9aanp4tEnIWRFoVEbW4AJP44OTmpxJ2N0i+Xy42ZmZlZbJ8CqkDNljDWAW+JjbJePHLmgw4L3o8COMgG/68ErPioloDYFH0i9qLD1s3VLHJubm760uYg50POlQUeXxup8cTn9PsKOf5Q/dPT03bv3APGdQAVebcoSOoHPvN94EjTVaNr8YAOV7KF+deDXIhVSyRs1Y6oTyLxBxmMe84nCbWTyaQBA7j7wgFILyQxf9Ti5/P5Jp9ZaaFY6dWiRJap+qOi49zlBVMXoGQHNICMrZnNzc1H3wbv/Py8w2s1z1U0iUjboCoy9Xrdq1Qqdz4gxq2IDqH2XdfEfHgIWLXVaul2pHo/IMZNwCQHomzNz8/rQyRsNpshaaGrAmT8dDodXFxc3I4bXP5scuhMTk7WFDUvD6OAVOB2BFdXVyEHNRspYdePjYv5IIm8OUtLSwUIKDmFFlwtr2udh0BKcFbaJBap0ZfARmEVjyg8Ojp6D0gnDo4S4eXlZQgvkQpRxEUNbd2d3D4KuGziBDQOkPuCrdA/G92EOxUlDBEtpIwlXfdFcXZ2FvBHpsU3vEeOcBS9gFEmZD7MZrPh1NRUyDoReDCJXgVMaPwE/MH8E/CG9l1KiIR9OM723kzHK7kJWIsXU5LW0zlAlUchMmxQ7tbWlre9vS3l/k29YX2ZdX8B/4+Cst1+y+EAAAAASUVORK5CYII=", import.meta.url).href : new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADN0lEQVRYCb2WS2sUQRRGM1HjK2LUgGgSEFRcuBBBECSCihv9AQFR0JU7V/of3AmCK8FFVpI/IIIvBBe6U/EFghJBBd+Kb6PjOcPcprrTQxK7xwtnbnV11b1fPbqmGj2ztGazOZ+mm2ArDMMqGATrP7Z5jr8FdxqNxhR+RmvM1ILEy2izD7bDUjDhvLa3XHz23U+4CuMIeYfvaB0FtEe8h567YTEUE0Xyog9x+l8wAQpR1DQrFUDyfloegnWQBiwmW8D7qEvLaR/LD+AEIt7ic9abe+KB5KtxR2EI/pTQpE608DEQvRg3UMAWOE/sjfic5QTQwDUeA2egU3LrUxE8ZknLkptDEWvhLDncuJmFckduowMwAtHJOolptv4+3INJ+ADaSvALGYVdsAhckuirj5h3KR+MPZEK2MELsWE0TgU8ov5C2TpSnxkDcemOwV4I4akAY58hzil8a+oc/RLKR2AhhIBUxDU63ODdrI2Yh2l8HGImQoRxv8MoMV/7oG0Dyx4ewW/KcmmuyenTQ59x3GlIZyFm1LNFcT29KDXxejCxCUOA/iGBbuL/yeh7jo5XIESEV8gYuftMvgb0xeQ/qLsOVe0kAfxqInn4Aep2mngEiskd/WNG4BlfyYjh13IZ0oMqROxXgOuRTrtlj9AnUJddJJACUhEuw2aV9IEzoMVnqX/Tqqnn5zZhTK6lOYZDgKNOzUZf04qK5Zf0DwERyhwjCigmt0Gc8ZYrG/vgM0HMNc2s/AL+B4TFOe+hVCYu2tXi3YQKiK/AzRe4ObtuCvgEjjRFEV65um4KeAUxA6mI5ZxU/qt11RTwHjz1ykQMdTU7wXvZoV4w/EwUUBTRzyzkLhC0qdWcAe0ZeGlMBYSgQUSssFE3rCWAWXDTvQD3QCSO/eDzgDMBHp+1WhyLXkosbwA3nssSQvQhRqGekK09g/DKB1YsgRcIgz2N4PhUgIICDy//P0pPNurnZJkAeyHCkU6C+yESxmzoFRm+8uiJ1bqI6DNDhNOriG+QioiyiWtJTpzsr9Fyztp7wuPYC6vJY4PGfphCrMtUybJN2CkKQlwmRbjmOSH/RUAqDDGKUHRrGeoQ8BdfJBsNaB/5WQAAAABJRU5ErkJggg==", import.meta.url).href);
    return (v, d) => (s(), c("div", {
      ref_key: "component",
      ref: i,
      class: z(["w-fit font-secondary font-[430] text-[14px] leading-[22px] rounded-md cursor-pointer flex items-center justify-center select-none transition", p.value]),
      style: q(n.value),
      role: "button"
    }, [
      l.loading ? (s(), c("img", {
        key: 0,
        src: h.value,
        class: "w-4 animate-spin"
      }, null, 8, vt)) : (s(), c("div", ut, [
        l.icon ? (s(), Z(H, {
          key: 0,
          name: l.icon,
          size: 18,
          class: z(r.value)
        }, null, 8, ["name", "class"])) : D("", !0),
        K(v.$slots, "default")
      ]))
    ], 6));
  }
}), _t = {}, gt = { class: "component bg-[#F6F7F7]" };
function ft(l, e) {
  return s(), c("div", gt);
}
const yt = /* @__PURE__ */ O(_t, [["render", ft], ["__scopeId", "data-v-182b413c"]]), Da = /* @__PURE__ */ g({
  __name: "Avatar",
  props: {
    src: {},
    size: {}
  },
  setup(l) {
    const e = l, t = u(() => ({
      minWidth: `${e.size}px`,
      maxWidth: `${e.size}px`,
      minHeight: `${e.size}px`,
      maxHeight: `${e.size}px`
    })), i = u(() => ({
      ...t.value,
      backgroundImage: `url("${e.src}")`
    }));
    return (a, o) => e.src ? (s(), c("div", {
      key: 0,
      class: "bg-cover bg-center rounded-full",
      style: q(i.value)
    }, null, 4)) : (s(), Z(yt, {
      key: 1,
      style: q(t.value),
      class: "rounded-full"
    }, null, 8, ["style"]));
  }
}), mt = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "FolderIcon_svg__folder",
  viewBox: "0 0 53 42"
};
function xt(l, e) {
  return s(), c("svg", mt, [...e[0] || (e[0] = [
    b('<defs><linearGradient id="FolderIcon_svg__b" x1="50%" x2="50%" y1="0%" y2="43.676%"><stop offset="0%" stop-color="#40A4D6"></stop><stop offset="100%" stop-color="#127BB0"></stop></linearGradient><linearGradient id="FolderIcon_svg__a" x1="97.231%" x2="97.231%" y1="52.769%" y2="47.231%"><stop offset="0%" stop-color="#0D6E9F"></stop><stop offset="100%" stop-color="#228EC4"></stop></linearGradient><linearGradient id="FolderIcon_svg__c" x1="100%" x2="94.461%" y1="50%" y2="50%"><stop offset="0%" stop-color="#48BAEF"></stop><stop offset="100%" stop-color="#65C7F4"></stop></linearGradient></defs><g fill="none" fill-rule="evenodd" transform="translate(.5 .5)"><path fill="url(#FolderIcon_svg__b)" stroke="url(#FolderIcon_svg__a)" d="M0 2a2 2 0 0 1 2-2h14.617a2 2 0 0 1 1.651.87L21.092 5 50 5a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" style="vector-effect:non-scaling-stroke;"></path><rect width="36" height="52" x="8" y="-3" fill="#75D0FA" stroke="url(#FolderIcon_svg__c)" rx="2" style="vector-effect:non-scaling-stroke;" transform="rotate(90 26 23)"></rect></g>', 2)
  ])]);
}
const It = { render: xt }, Pt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Mt(l, e) {
  return s(), c("svg", Pt, [...e[0] || (e[0] = [
    b('<defs><clipPath id="AudioIcon_svg__a"><rect width="52" height="39" x="1" y="7.5" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="AudioIcon_svg__b"><path d="M16.75 22.75h1.5v8.5h-1.5z" style="fill:none;"></path></clipPath><clipPath id="AudioIcon_svg__c"><path d="M25.75 22.75h1.5v8.5h-1.5z" style="fill:none;"></path></clipPath><clipPath id="AudioIcon_svg__d"><path d="M35.75 22.75h1.5v8.5h-1.5z" style="fill:none;"></path></clipPath><clipPath id="AudioIcon_svg__e"><path d="M21.25 15h1.5v24h-1.5z" style="fill:none;"></path></clipPath><clipPath id="AudioIcon_svg__f"><path d="M30.75 19.5h1.5v15h-1.5z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#AudioIcon_svg__a);"><path d="M0 6.5h54v41H0z" style="fill:#f8f9fa;"></path></g><rect width="52" height="39" x="1" y="7.5" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#AudioIcon_svg__b);"><path d="M15.75 21.75h3.5v10.5h-3.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#AudioIcon_svg__c);"><path d="M24.75 21.75h3.5v10.5h-3.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#AudioIcon_svg__d);"><path d="M34.75 21.75h3.5v10.5h-3.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#AudioIcon_svg__e);"><path d="M20.25 14h3.5v26h-3.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#AudioIcon_svg__f);"><path d="M29.75 18.5h3.5v17h-3.5z" style="fill:#2d2d2d;"></path></g>', 8)
  ])]);
}
const bt = { render: Mt }, At = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function wt(l, e) {
  return s(), c("svg", At, [...e[0] || (e[0] = [
    b('<defs><clipPath id="CodeIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="CodeIcon_svg__b"><path d="M26.75 32.583h11.5v1.5h-11.5z" style="fill:none;"></path></clipPath><clipPath id="CodeIcon_svg__c"><path d="m16.439 20 1.061-1.061 7.727 7.728-7.727 7.727-1.061-1.061 6.667-6.667z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#CodeIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#CodeIcon_svg__b);"><path d="M25.75 31.583h13.5v3.5h-13.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#CodeIcon_svg__c);"><path d="M15.439 17.939h10.788v17.455H15.439z" style="fill:#2d2d2d;"></path></g>', 5)
  ])]);
}
const zt = { render: wt }, kt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function St(l, e) {
  return s(), c("svg", kt, [...e[0] || (e[0] = [
    b('<defs><clipPath id="ImageIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="ImageIcon_svg__b"><path d="M20.5 16.75a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5m0-1.5c-2.348 0-4.25 1.902-4.25 4.25s1.902 4.25 4.25 4.25 4.25-1.902 4.25-4.25-1.902-4.25-4.25-4.25" style="fill:none;"></path></clipPath><clipPath id="ImageIcon_svg__c"><path d="M28.938 26.637a2.426 2.426 0 0 1 3.203.516l.1.135 6.802 9.907-1.237.849-6.803-9.907a.924.924 0 0 0-1.419-.099l-.069.084-4.827 6.697-3.324-2.589a.93.93 0 0 0-1.277.141l-.039.052-3.854 5.621-1.237-.848 3.858-5.627.083-.114.038-.047a2.426 2.426 0 0 1 3.205-.465l.143.103 2.095 1.632 3.919-5.435a2.4 2.4 0 0 1 .493-.504l.146-.102Z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#ImageIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><circle cx="20.5" cy="19.5" r="3.5" style="fill:none;stroke:#2d2d2d;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;"></circle><path d="m38 37-6.377-9.288c-.502-.734-1.522-.932-2.278-.445q-.258.167-.437.415l-4.372 6.065-2.71-2.111a1.675 1.675 0 0 0-2.395.362L16.001 37" style="fill:none;stroke:#2d2d2d;stroke-linecap:square;stroke-miterlimit:10;stroke-width:1.5px;"></path><g style="clip-path:url(#ImageIcon_svg__b);"><path d="M15.25 14.25h10.5v10.5h-10.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#ImageIcon_svg__c);"><path d="M13.957 24.961h26.086v14.082H13.957z" style="fill:#2d2d2d;"></path></g>', 7)
  ])]);
}
const Dt = { render: St }, Ct = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Rt(l, e) {
  return s(), c("svg", Ct, [...e[0] || (e[0] = [
    b('<defs><clipPath id="AdobeAcrobat_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="AdobeAcrobat_svg__b"><path d="M38.483 29.619c-1.792-1.862-6.689-1.104-7.86-.966-1.722-1.655-2.896-3.655-3.307-4.345.621-1.86 1.032-3.723 1.102-5.72 0-1.725-.691-3.587-2.621-3.587-.689 0-1.309.413-1.655.966-.826 1.447-.483 4.343.828 7.307-.758 2.138-1.449 4.206-3.379 7.86-2 .826-6.206 2.758-6.549 4.826-.138.621.068 1.242.551 1.722a2.64 2.64 0 0 0 1.722.623c2.553 0 5.034-3.517 6.759-6.481 1.447-.483 3.722-1.174 5.998-1.585 2.691 2.343 5.034 2.689 6.275 2.689 1.655 0 2.275-.691 2.481-1.312.345-.688.14-1.447-.345-1.998m-1.722 1.172c-.07.481-.691.964-1.792.688a9.5 9.5 0 0 1-3.517-1.792c.896-.138 2.896-.343 4.343-.068.553.136 1.104.481.966 1.172M25.246 16.587c.138-.208.343-.345.551-.345.621 0 .761.758.761 1.379a15.2 15.2 0 0 1-.828 4.275c-1.034-2.758-.828-4.689-.483-5.309m-.138 13.375c.551-1.102 1.309-3.034 1.587-3.86.621 1.032 1.653 2.275 2.206 2.826 0 .07-2.138.483-3.792 1.034m-4.068 2.759c-1.587 2.619-3.242 4.275-4.136 4.275-.14 0-.278-.068-.415-.138q-.31-.207-.206-.621c.206-.966 1.998-2.278 4.756-3.517" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AdobeAcrobat_svg__c"><path d="M15 15h24v23.305H15z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#AdobeAcrobat_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#AdobeAcrobat_svg__b);"><g style="clip-path:url(#AdobeAcrobat_svg__c);"><path d="M14 14h26v25.305H14z" style="fill:#e53935;"></path></g></g>', 4)
  ])]);
}
const Et = { render: Rt }, Vt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Bt(l, e) {
  return s(), c("svg", Vt, [...e[0] || (e[0] = [
    b('<defs><clipPath id="VideoIcon_svg__a"><rect width="52" height="39" x="1" y="7.5" rx="2" ry="2" style="fill:none;"></rect></clipPath></defs><g style="clip-path:url(#VideoIcon_svg__a);"><path d="M0 6.5h54v41H0z" style="fill:#f8f9fa;"></path></g><rect width="52" height="39" x="1" y="7.5" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><path d="m20.75 20.726 13.605 6.97-13.605 6.97zm-1.5-1.226v16.393a.75.75 0 0 0 1.092.668l16-8.196a.75.75 0 0 0 0-1.335l-16-8.196a.75.75 0 0 0-1.092.668Z" style="fill:#2d2d2d;vector-effect:non-scaling-stroke;"></path>', 4)
  ])]);
}
const Ht = { render: Bt }, $t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Ft(l, e) {
  return s(), c("svg", $t, [...e[0] || (e[0] = [
    b('<defs><clipPath id="TextIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath></defs><g style="clip-path:url(#TextIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><path d="M15.75 33.75h11.5M15.75 28.75h22.5M15.75 23.75h22.5M15.75 18.75h22.5" style="fill:none;stroke:#2d2d2d;stroke-linecap:square;stroke-miterlimit:10;stroke-width:1.5px;"></path>', 4)
  ])]);
}
const Ut = { render: Ft }, qt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Tt(l, e) {
  return s(), c("svg", qt, [...e[0] || (e[0] = [
    b('<defs><clipPath id="PowerPointIcon_svg__a"><rect width="52" height="39" x="1" y="7.5" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="PowerPointIcon_svg__b"><path d="M16.4 27.5c0 6.076 4.835 11 10.8 11S38 33.576 38 27.5z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="PowerPointIcon_svg__c"><path d="M27.2 16.5v11H38c0-6.076-4.835-11-10.8-11" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="PowerPointIcon_svg__d"><path d="M27.2 16.5c-5.965 0-10.8 4.924-10.8 11h10.8z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="PowerPointIcon_svg__e"><path d="M24.991 33.611h-9.983c-.557 0-1.009-.46-1.009-1.027V22.415c0-.567.452-1.027 1.009-1.027h9.983c.557 0 1.008.46 1.008 1.027v10.169c0 .567-.451 1.027-1.008 1.027" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="PowerPointIcon_svg__f"><path d="M14 21.389h11.999v12.222H14z" style="fill:none;"></path></clipPath><clipPath id="PowerPointIcon_svg__g"><path d="M20.403 24.452H17.6v6.111h1.214v-2.152h1.366c1.126 0 2.038-.929 2.038-2.075v-.035c0-1.021-.812-1.848-1.814-1.848Zm.539 2.045a.943.943 0 0 1-.934.951h-1.194v-2.033h1.194c.515 0 .934.426.934.951z" style="clip-rule:evenodd;fill:none;"></path></clipPath></defs><g style="clip-path:url(#PowerPointIcon_svg__a);"><path d="M0 6.5h54v41H0z" style="fill:#f8f9fa;"></path></g><rect width="52" height="39" x="1" y="7.5" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#PowerPointIcon_svg__b);"><path d="M15.4 26.5H39v13H15.4z" style="fill:#dc4c2c;"></path></g><g style="clip-path:url(#PowerPointIcon_svg__c);"><path d="M26.2 15.5H39v13H26.2z" style="fill:#f7a278;"></path></g><g style="clip-path:url(#PowerPointIcon_svg__d);"><path d="M15.4 15.5h12.8v13H15.4z" style="fill:#c06346;"></path></g><g style="clip-path:url(#PowerPointIcon_svg__e);"><g style="clip-path:url(#PowerPointIcon_svg__f);"><path d="M13 20.389h13.999v14.222H13z" style="fill:#9b341f;"></path></g></g><g style="clip-path:url(#PowerPointIcon_svg__g);"><path d="M16.6 23.452h6.618v8.111H16.6z" style="fill:#fff;"></path></g>', 8)
  ])]);
}
const Wt = { render: Tt }, Lt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function jt(l, e) {
  return s(), c("svg", Lt, [...e[0] || (e[0] = [
    b('<defs><clipPath id="TableIcon_svg__a"><rect width="52" height="39" x="1" y="7.5" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="TableIcon_svg__b"><path d="M38.5 19v17h-23V19zm1-1h-25v19h25z" style="fill:none;"></path></clipPath><clipPath id="TableIcon_svg__c"><path d="M22.5 18.5h1v18h-1z" style="fill:none;"></path></clipPath><clipPath id="TableIcon_svg__d"><path d="M14.5 24h25v1h-25z" style="fill:none;"></path></clipPath><clipPath id="TableIcon_svg__e"><path d="M30.5 18.5h1v18h-1z" style="fill:none;"></path></clipPath><clipPath id="TableIcon_svg__f"><path d="M14.5 30h25v1h-25z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#TableIcon_svg__a);"><path d="M0 6.5h54v41H0z" style="fill:#f8f9fa;"></path></g><rect width="52" height="39" x="1" y="7.5" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#TableIcon_svg__b);"><path d="M13.5 17h27v21h-27z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#TableIcon_svg__c);"><path d="M21.5 17.5h3v20h-3z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#TableIcon_svg__d);"><path d="M13.5 23h27v3h-27z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#TableIcon_svg__e);"><path d="M29.5 17.5h3v20h-3z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#TableIcon_svg__f);"><path d="M13.5 29h27v3h-27z" style="fill:#2d2d2d;"></path></g>', 8)
  ])]);
}
const Ot = { render: jt }, Zt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Gt(l, e) {
  return s(), c("svg", Zt, [...e[0] || (e[0] = [
    b('<defs><clipPath id="ThreeDIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="ThreeDIcon_svg__b"><path d="m16.25 21.505 10.25 4.659v11.171l-10.25-4.659zm-1.5-1.164v12.818a.75.75 0 0 0 .44.683l11.75 5.341A.75.75 0 0 0 28 38.5V25.682a.75.75 0 0 0-.44-.683l-11.75-5.341a.75.75 0 0 0-1.06.683" style="fill:none;"></path></clipPath><clipPath id="ThreeDIcon_svg__c"><path d="M38.25 21.505v11.171L28 37.335V26.164zm.44-1.847-11.75 5.341a.75.75 0 0 0-.44.683V38.5a.75.75 0 0 0 1.06.683l11.75-5.341a.75.75 0 0 0 .44-.683V20.341a.75.75 0 0 0-1.06-.683" style="fill:none;"></path></clipPath><clipPath id="ThreeDIcon_svg__d"><path d="M26.94 14.317a.75.75 0 0 1 .52-.037l.101.037 11.75 5.341-.621 1.366-11.44-5.201-11.44 5.201-.621-1.366 11.75-5.341Z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#ThreeDIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><path d="M13.75 18.432H29v21.976H13.75z" style="clip-path:url(#ThreeDIcon_svg__b);"></path><path d="M25.5 18.432h15.25v21.976H25.5z" style="clip-path:url(#ThreeDIcon_svg__c);"></path><path d="M14.19 13.23h26.121v8.794H14.19z" style="clip-path:url(#ThreeDIcon_svg__d);"></path>', 6)
  ])]);
}
const Nt = { render: Gt }, Qt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Kt(l, e) {
  return s(), c("svg", Qt, [...e[0] || (e[0] = [
    b('<defs><clipPath id="AfterEffectsIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="AfterEffectsIcon_svg__b"><path d="M24.851 31.531h-5.207l-.987 3.253H15.5L20.865 19h2.75l5.394 15.784h-3.157zm-4.405-2.633h3.605l-1.81-5.911zm14.65 6.103q-1.248-.002-2.233-.446a5 5 0 0 1-1.673-1.214 5.3 5.3 0 0 1-1.049-1.806 6.7 6.7 0 0 1-.361-2.217v-.423q0-1.332.352-2.446c.233-.738.567-1.378 1.001-1.911q.646-.804 1.573-1.253a4.7 4.7 0 0 1 2.073-.453q1.156.002 2.039.418c.883.416 1.079.67 1.479 1.173q.598.752.901 1.815.303 1.064.304 2.364v1.335h-6.819q.069.575.281 1.04.214.466.544.798.332.329.777.514.446.185.999.185.782 0 1.445-.32a2.96 2.96 0 0 0 1.138-.992l1.406 1.721q-.257.404-.642.782a4.5 4.5 0 0 1-.912.677 5 5 0 0 1-1.182.478q-.658.18-1.44.18Zm-.327-9.628q-.467 0-.816.181a1.8 1.8 0 0 0-.603.498 2.6 2.6 0 0 0-.411.763 4.7 4.7 0 0 0-.226.985h3.977v-.247a3.3 3.3 0 0 0-.123-.869 2 2 0 0 0-.345-.693 1.56 1.56 0 0 0-.594-.455 2.1 2.1 0 0 0-.857-.165Z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AfterEffectsIcon_svg__c"><path d="M15.5 19h24v16h-24z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#AfterEffectsIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#AfterEffectsIcon_svg__b);"><g style="clip-path:url(#AfterEffectsIcon_svg__c);"><path d="M14.5 18h26v18h-26z" style="fill:#b388ff;"></path></g></g>', 4)
  ])]);
}
const Yt = { render: Kt }, Xt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Jt(l, e) {
  return s(), c("svg", Xt, [...e[0] || (e[0] = [
    b('<defs><clipPath id="AuditionIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="AuditionIcon_svg__b"><path d="m21.655 23.537 1.651 5.979h-3.303l1.651-5.979ZM20.028 19 14.5 35.772h3.779l.947-3.434h4.872l.947 3.432h3.813L23.296 19z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AuditionIcon_svg__c"><path d="M36.727 34.63Q35.674 36 33.907 36q-1.782 0-2.701-1.18-.92-1.176-.92-3.439v-8.738h3.381v8.821q.025 1.819 1.256 1.819 1.159.001 1.673-.967v-9.673h3.405V35.77h-3.179z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AuditionIcon_svg__d"><path d="M30.286 22.642h9.715v13.357h-9.715z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#AuditionIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#AuditionIcon_svg__b);"><path d="M13.5 18h16.358v18.772H13.5z" style="fill:#99f;"></path></g><g style="clip-path:url(#AuditionIcon_svg__c);"><g style="clip-path:url(#AuditionIcon_svg__d);"><path d="M29.286 21.642h11.715v15.357H29.286z" style="fill:#99f;"></path></g></g>', 5)
  ])]);
}
const el = { render: Jt }, tl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function ll(l, e) {
  return s(), c("svg", tl, [...e[0] || (e[0] = [
    b('<defs><clipPath id="IllustratorIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="IllustratorIcon_svg__b"><path d="M34.374 21.484q.823 0 1.301-.498.482-.498.481-1.249 0-.765-.486-1.252-.488-.485-1.297-.486c-.809-.001-.974.161-1.297.486q-.485.487-.486 1.252-.001.75.481 1.249c.32.332.751.498 1.301.498" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="IllustratorIcon_svg__c"><path d="M22.001 32.05h4.641l.903 3.449h3.636l-5.302-16.85h-3.115L17.5 35.499h3.598zm2.316-8.841 1.574 6.006h-3.148z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="IllustratorIcon_svg__d"><path d="M32.743 22.978h3.285V35.5h-3.285z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#IllustratorIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#IllustratorIcon_svg__b);"><path d="M31.592 17h5.565v5.484h-5.565z" style="fill:#fe9901;"></path></g><g style="clip-path:url(#IllustratorIcon_svg__c);"><path d="M16.5 17.648h15.681v18.85H16.5z" style="fill:#fe9901;"></path></g><g style="clip-path:url(#IllustratorIcon_svg__d);"><path d="M31.743 21.978h5.285V36.5h-5.285z" style="fill:#fe9901;"></path></g>', 6)
  ])]);
}
const al = { render: ll }, il = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function nl(l, e) {
  return s(), c("svg", il, [...e[0] || (e[0] = [
    b('<defs><clipPath id="InDesignIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="InDesignIcon_svg__b"><path d="M20.5 18.914h3.357v16.621H20.5z" style="fill:none;"></path></clipPath><clipPath id="InDesignIcon_svg__c"><path d="M30.088 35.764q1.565 0 2.558-1.485l.147 1.255h2.934V17.999h-3.252v6.189q-.95-1.233-2.375-1.232-1.962 0-2.993 1.494-1.025 1.497-1.026 4.533v.935q.024 2.876 1.045 4.36t2.962 1.485Zm-.765-6.827q0-1.838.411-2.558.411-.718 1.3-.718.96 0 1.44.914v5.639q-.49.855-1.452.856-.924-.001-1.312-.725-.389-.726-.388-2.553z" style="clip-rule:evenodd;fill:none;"></path></clipPath></defs><g style="clip-path:url(#InDesignIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#InDesignIcon_svg__b);"><path d="M19.5 17.914h5.357v18.621H19.5z" style="fill:#e91e63;"></path></g><g style="clip-path:url(#InDesignIcon_svg__c);"><path d="M25.081 17h11.647v19.764H25.081z" style="fill:#e91e63;"></path></g>', 5)
  ])]);
}
const sl = { render: nl }, ol = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function cl(l, e) {
  return s(), c("svg", ol, [...e[0] || (e[0] = [
    b('<defs><clipPath id="PhotoshopIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="PhotoshopIcon_svg__b"><path d="M19.395 29.872h2.264c1.731 0 3.087-.474 4.064-1.43q1.469-1.426 1.469-3.892c0-2.466-.497-2.979-1.485-4.008Q24.222 19 21.731 18.999H16v16.77h3.397v-5.897Zm0-8.051h2.368q.913.014 1.455.755.543.743.544 1.998 0 1.21-.532 1.845-.532.633-1.5.632h-2.335z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="PhotoshopIcon_svg__c"><path d="M16 19h11.192v16.77H16z" style="fill:none;"></path></clipPath><clipPath id="PhotoshopIcon_svg__d"><path d="M33.508 33.615q-.854 0-1.23-.425-.376-.428-.4-1.279h-3.106q0 1.106.596 2.059a4.04 4.04 0 0 0 1.644 1.493c.703.356 1.509.535 2.427.535q2.045 0 3.302-1.012 1.259-1.015 1.258-2.685c0-.96-.272-1.741-.826-2.345q-.824-.903-2.822-1.642c-.918-.392-1.497-.694-1.746-.906q-.371-.316-.371-.731 0-.574.336-.896t.856-.323q1.27 0 1.27 1.519h3.267c0-1.189-.409-2.137-1.235-2.843q-1.24-1.06-3.29-1.059-1.951 0-3.136 1.064-1.185 1.066-1.185 2.701 0 1.3.757 2.177.76.877 2.779 1.694 1.374.6 1.772.948.399.352.4.767 0 1.188-1.317 1.187" style="clip-rule:evenodd;fill:none;"></path></clipPath></defs><g style="clip-path:url(#PhotoshopIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#PhotoshopIcon_svg__b);"><g style="clip-path:url(#PhotoshopIcon_svg__c);"><path d="M15 18h13.192v18.77H15z" style="fill:#03a9f4;"></path></g></g><g style="clip-path:url(#PhotoshopIcon_svg__d);"><path d="M27.773 22.078H39V37H27.773z" style="fill:#03a9f4;"></path></g>', 5)
  ])]);
}
const rl = { render: cl }, hl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function pl(l, e) {
  return s(), c("svg", hl, [...e[0] || (e[0] = [
    b('<defs><clipPath id="PremierProIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="PremierProIcon_svg__b"><path d="M20.915 29.444h2.169q2.489.001 3.893-1.373 1.407-1.37 1.407-3.739c0-2.369-.476-2.862-1.423-3.85Q25.54 19 23.152 19h-5.651v16.109h3.415zm0-7.734h2.268a1.67 1.67 0 0 1 1.394.725q.52.713.521 1.919 0 1.163-.51 1.772-.51.608-1.437.607h-2.237v-5.024Z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="PremierProIcon_svg__c"><path d="M34.268 27.178c.227-.793.793-1.133 1.7-1.133l1.02.113.113-3.172c-.227-.113-.566-.113-.906-.113-.906 0-1.586.453-2.039 1.473l-.113-1.246h-2.946v12.01h3.172v-7.931Z" style="clip-rule:evenodd;fill:none;"></path></clipPath></defs><g style="clip-path:url(#PremierProIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#PremierProIcon_svg__b);"><path d="M16.5 18h12.884v18.109H16.5z" style="fill:#e040fb;"></path></g><g style="clip-path:url(#PremierProIcon_svg__c);"><path d="M30.096 21.873h8.005v14.236h-8.005z" style="fill:#e040fb;"></path></g>', 5)
  ])]);
}
const dl = { render: pl }, vl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function ul(l, e) {
  return s(), c("svg", vl, [...e[0] || (e[0] = [
    b('<defs><clipPath id="AutocadIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="AutocadIcon_svg__b"><path d="M32.753 27.606c-.06-.138-.102-.228-.108-.252v-.006c-.384-.87-.75-1.686-1.104-2.436-.048-.108-.102-.216-.15-.324q-.09-.197-.18-.384c-1.452-3.108-2.55-5.094-3.264-5.928-.162-.192-.39-.276-.648-.276s-.486.084-.648.276c-.714.834-1.812 2.82-3.264 5.928q-.09.188-.18.384c-.048.108-.102.216-.15.324-.354.75-.72 1.566-1.104 2.436v.006c-.006.024-.048.114-.108.252-.328.738-1.268 2.886-1.694 3.845l.754-.299c.93-.382 1.876-.739 2.814-1.072l.018-.008c.078-.192.455-1.152.527-1.338q.27-.675.522-1.296c.018-.036.03-.078.048-.114q.27-.668.522-1.272c.036-.09.078-.174.114-.264q.089-.206.168-.402.135-.314.252-.6.151-.35.294-.672.243-.55.432-.984c.048-.114.102-.222.144-.324q.224-.494.366-.798.129-.287.174-.382.046.096.174.382.143.305.366.798c.042.102.096.21.144.324q.189.433.432.984.143.322.294.672.117.287.252.6.08.197.168.402c.036.09.078.174.114.264q.252.605.522 1.272c.018.036.03.078.048.114q.252.621.522 1.296c.072.186.449 1.146.527 1.338l.018.008c.938.332 1.884.69 2.815 1.072l.752.299c-.426-.959-1.367-3.107-1.694-3.845" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__c"><path d="M22.985 33.372c-.438 2.196-.486 4.428-.486 4.428l-1.8 1.2h-3l1.782-5.628z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__d"><path d="M22.517 33.372A124 124 0 0 0 20.699 39h-3l1.782-5.628z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__e"><path d="M36.899 39h-3l-1.8-1.2s-.072-3.528-.9-6.078c-.006-.024-.018-.048-.024-.072h3.396z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__f"><path d="M31.211 24.204q.09.188.18.384c.048.108.102.216.15.324.354.75.72 1.566 1.104 2.436v.006c.006.024.048.114.108.252q.062.144.15.342c.018.036.036.084.054.126q.08.173.168.372.044.106.096.222c.216.486.456 1.038.684 1.554.072.168.144.336.216.492q.063.153.126.288.112.254.2.45l-.752-.3a66 66 0 0 0-2.832-1.079l-.528-1.339q-.27-.675-.522-1.296c-.018-.036-.03-.078-.048-.114q-.27-.668-.522-1.272c-.036-.09-.078-.174-.114-.264q-.088-.206-.168-.402-.135-.314-.252-.6-.152-.35-.294-.672-.243-.55-.432-.984c-.048-.114-.102-.222-.144-.324q-.223-.494-.366-.798z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__g"><path d="M36.899 39h-3a113 113 0 0 0-2.436-7.332q.002 0-.006-.018h3.114z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__h"><path d="m32.897 27.883-.204-.462-.491.122c-2.424.604-7.032 1.856-11.299 3.61l-.749.296-.097.241c-.402.947-.778 1.849-1.123 2.682l.715-.173s3.75-1.05 14.324-2.4l.58-.078a274 274 0 0 0-1.656-3.839" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__i"><path d="M23.387 24.204q-.09.188-.18.384c-.048.108-.102.216-.15.324-.354.75-.72 1.566-1.104 2.436v.006c-.006.024-.048.114-.108.252q-.061.144-.15.342c-.018.036-.036.084-.054.126q-.08.173-.168.372-.044.106-.096.222c-.216.486-.456 1.038-.684 1.554-.072.168-.144.336-.216.492a7 7 0 0 1-.126.288q-.112.254-.2.45l.752-.3c.937-.384 1.89-.743 2.832-1.079l.528-1.339q.27-.675.522-1.296c.018-.036.03-.078.048-.114q.27-.668.522-1.272c.036-.09.078-.174.114-.264q.088-.206.168-.402.135-.314.252-.6.152-.35.294-.672.243-.55.432-.984c.048-.114.102-.222.144-.324q.223-.494.366-.798z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__j"><path d="M21.845 27.606q-.062.144-.15.342c-.018.036-.036.084-.054.126q-.08.173-.168.372c-.03.072-.066.144-.096.222-.216.486-.456 1.038-.684 1.554-.072.168-.144.336-.216.492a7 7 0 0 1-.126.288c-.052.116-.131.3-.196.448l.748-.298c.936-.384 1.89-.744 2.832-1.079.242-.613.491-1.243.527-1.339q.27-.675.522-1.296c.018-.036.031-.078.049-.114q.27-.668.521-1.272c.036-.09.079-.174.115-.264q.088-.206.168-.402z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__k"><path d="m36.9 39 1.2-.6s-.607-3.192-1.902-7.746C34.92 26.166 32.982 20.364 30.3 15h-6c-2.682 5.364-4.621 11.166-5.898 15.654C17.106 35.208 16.5 38.4 16.5 38.4l1.2.6s1.267-3.196 2.91-7.075c4.451-1.884 9.46-3.232 11.738-3.8A358 358 0 0 1 36.9 39.001Zm-15.552-8.803c2.06-4.787 4.471-10.025 5.736-11.507a.28.28 0 0 1 .216-.09.28.28 0 0 1 .216.089c.774.908 1.978 3.223 3.266 5.98z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__l"><path d="M16.5 15h21.599v24H16.5z" style="fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__m"><path d="M28.499 15s4.458 6.6 7.68 15.6l.018.054c-1.278-4.488-3.216-10.29-5.898-15.654z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="AutocadIcon_svg__n"><path d="M26.099 15s-4.458 6.6-7.68 15.6l-.018.054c1.278-4.488 3.216-10.29 5.898-15.654z" style="clip-rule:evenodd;fill:none;"></path></clipPath></defs><g style="clip-path:url(#AutocadIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#AutocadIcon_svg__b);"><path d="M19.151 17h16.297v15.451H19.151z" style="fill:#6d4c41;"></path></g><g style="clip-path:url(#AutocadIcon_svg__c);"><path d="M16.699 32.372h7.286V40h-7.286z" style="fill:#c62828;"></path></g><g style="clip-path:url(#AutocadIcon_svg__d);"><path d="M16.699 32.372h6.818V40h-6.818z" style="fill:#e57373;"></path></g><g style="clip-path:url(#AutocadIcon_svg__e);"><path d="M30.175 30.65h7.724V40h-7.724z" style="fill:#c62828;"></path></g><g style="clip-path:url(#AutocadIcon_svg__f);"><path d="M26.473 21.008h8.974v11.444h-8.974z" style="fill:#8d6e63;"></path></g><g style="clip-path:url(#AutocadIcon_svg__g);"><path d="M30.457 30.65h7.442V40h-7.442z" style="fill:#e57373;"></path></g><g style="clip-path:url(#AutocadIcon_svg__h);"><path d="M17.934 26.421h17.619v8.952H17.934z" style="fill:#b71c1c;"></path></g><g style="clip-path:url(#AutocadIcon_svg__i);"><path d="M19.151 21.008h8.974v11.444h-8.974z" style="fill:#8d6e63;"></path></g><g style="clip-path:url(#AutocadIcon_svg__j);"><path d="M19.156 24.386h7.482v8.064h-7.482z" style="fill:#e57373;"></path></g><g style="clip-path:url(#AutocadIcon_svg__k);"><g style="clip-path:url(#AutocadIcon_svg__l);"><path d="M15.5 14h23.599v26H15.5z" style="fill:#d32f2f;"></path></g></g><g style="clip-path:url(#AutocadIcon_svg__m);"><path d="M27.499 14h9.698v17.654h-9.698z" style="fill:#e53935;"></path></g><g style="clip-path:url(#AutocadIcon_svg__n);"><path d="M17.401 14h9.698v17.654h-9.698z" style="fill:#c62828;"></path></g>', 15)
  ])]);
}
const _l = { render: ul }, gl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function fl(l, e) {
  return s(), c("svg", gl, [...e[0] || (e[0] = [
    b('<defs><clipPath id="FusionIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="FusionIcon_svg__b"><path d="M19.5 16.582v10.27l.606 11.516c1.848.37 3.973.572 6.341.632v-5.141c-.068-2.473 1.105-3.595 3.234-3.958l4.921-.643-1.391-3.422c-2.403-.377-4.489-.829-5.554-1.363-1.354-.709-1.789-2.315-.632-3.526.385-.403 1.424-.888 2.602-.896h5.616l-1.017-3.738c-2.193-.69-6.037-.981-10.055-1.315-1.435.269-2.967.808-4.672 1.583" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="FusionIcon_svg__c"><path d="M19.5 15h15.744v24H19.5z" style="fill:none;"></path></clipPath><clipPath id="FusionIcon_svg__d"><path d="m29.681 29.9 4.921-.642-1.391-3.423c-2.403-.376-4.489-.829-5.554-1.362-1.354-.71-1.789-2.317-.632-3.527.385-.403 1.424-.888 2.602-.894h5.204c-2.31-.494-4.213-.918-6.121-.947-3.594-.056-5.891 1.756-6.158 4.737-.171 1.892-.008 3.936.736 6.316.72 2.306 1.708 5.425 3.158 8.655v-4.955c-.068-2.472 1.105-3.595 3.234-3.957" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="FusionIcon_svg__e"><path d="M26.447 27.316c0 .873.706 1.579 1.579 1.579h6.428l-1.243-3.059q-.306-.049-.604-.099h-4.581c-.873 0-1.579.706-1.579 1.579" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="FusionIcon_svg__f"><path d="M23.869 15.21s-.24.322-.571.937c-.164.307-.354.686-.538 1.133a17.846 17.846 0 0 0-1.013 3.383l-.164 1.032c-.033.355-.088.715-.119 1.084a27 27 0 0 0-.077 2.276c.013.777.082 1.556.198 2.338a22.7 22.7 0 0 0 1.115 4.489c.501 1.389 1.136 2.63 1.717 3.676a69 69 0 0 0 1.454 2.504l.577.937s-.258-.307-.678-.869c-.414-.566-1.017-1.369-1.657-2.391-.631-1.023-1.374-2.237-1.933-3.658a20.5 20.5 0 0 1-1.219-4.598 18.5 18.5 0 0 1-.183-2.419c.002-.803.053-1.584.135-2.342.085-.755.227-1.478.388-2.156.174-.674.361-1.306.577-1.873.206-.571.441-1.076.672-1.511.226-.438.451-.803.643-1.099.393-.585.676-.873.676-.873" style="clip-rule:evenodd;fill:none;"></path></clipPath></defs><g style="clip-path:url(#FusionIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#FusionIcon_svg__b);"><g style="clip-path:url(#FusionIcon_svg__c);"><path d="M18.5 14h17.744v26H18.5z" style="fill:#fb8c00;"></path></g></g><g style="clip-path:url(#FusionIcon_svg__d);"><path d="M21.382 18.05h14.45v21.763h-14.45z" style="fill:#ffcc80;"></path></g><g style="clip-path:url(#FusionIcon_svg__e);"><path d="M25.447 24.737h10.007v5.158H25.447z" style="fill:#fb8c00;"></path></g><g style="clip-path:url(#FusionIcon_svg__f);"><path d="M19.778 14.21h7.67v25.789h-7.67z" style="fill:#ffcc80;"></path></g>', 7)
  ])]);
}
const yl = { render: fl }, ml = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function xl(l, e) {
  return s(), c("svg", ml, [...e[0] || (e[0] = [
    b('<defs><clipPath id="MayaIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="MayaIcon_svg__b"><path d="M33.185 25.68v10.794l1.263 1.262h.63V22.667z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MayaIcon_svg__c"><path d="M39.5 15.632s-1.263 15.789-4.421 22.105h-.632s-.076-6.316-.947-11.053l-.316-1.004 1.895-3.013zM19.921 25.737h1.263v.632l.632 10.105s-1.263 1.263-5.053 1.263H15.5z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MayaIcon_svg__d"><path d="M34.447 37.737s3.947-11.131 5.053-22.105v22.105zM15.5 15.632v22.105l5.684-11.368V15.632z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MayaIcon_svg__e"><path d="M30.026 33.316 39.5 15.632h-7.259l-7.267 17.684h5.052" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MayaIcon_svg__f"><path d="M15.5 15.632 22.763 15l7.263 18.316h-5.052l-3.79-6.948z" style="clip-rule:evenodd;fill:none;"></path></clipPath></defs><g style="clip-path:url(#MayaIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#MayaIcon_svg__b);"><path d="M32.185 21.667h3.894v17.069h-3.894z" style="fill:#0097a7;"></path></g><g style="clip-path:url(#MayaIcon_svg__c);"><path d="M14.5 14.632h26v24.105h-26z" style="fill:#00838f;"></path></g><g style="clip-path:url(#MayaIcon_svg__d);"><path d="M14.5 14.632h26v24.105h-26z" style="fill:#0097a7;"></path></g><g style="clip-path:url(#MayaIcon_svg__e);"><path d="M23.974 14.632H40.5v19.684H23.974z" style="fill:#33bdcd;"></path></g><g style="clip-path:url(#MayaIcon_svg__f);"><path d="M14.5 14h16.526v20.316H14.5z" style="fill:#80d5e0;"></path></g>', 8)
  ])]);
}
const Il = { render: xl }, Pl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Ml(l, e) {
  return s(), c("svg", Pl, [...e[0] || (e[0] = [
    b('<defs><clipPath id="Cinema4dIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="Cinema4dIcon_svg__b"><path d="M27.823 15.573c5.857 0 10.604 5.004 10.604 11.177S33.68 37.927 27.823 37.927 17.219 32.923 17.219 26.75s4.747-11.177 10.604-11.177" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="Cinema4dIcon_svg__c"><path d="M29.829 16.091c4.748 0 8.598 3.726 8.598 8.32s-3.849 8.32-8.598 8.32-8.598-3.726-8.598-8.32 3.849-8.32 8.598-8.32" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="Cinema4dIcon_svg__d"><path d="M29.256 16.719s2.866 1.146 1.661 2.168c-.609.517-1.384.79-2.105 1.128-.839.392-1.702.734-2.461 1.283-.572.415-1.113.861-1.502 1.461a4.76 4.76 0 0 0-.786 2.36 4.6 4.6 0 0 0 .422 2.212c.459.997 1.201 1.728 2.177 2.23a4.5 4.5 0 0 0 2.208.504 4.5 4.5 0 0 0 2.501-.799c.428-.294.768-.667 1.089-1.076.371-.475.671-.984.928-1.52.32-.667.562-1.366.827-2.055.204-.529.412-1.06.727-1.531 1.192-1.778 2.339-.059 2.339-.059s-.573-2.293-2.293-4.012c-1.719-1.72-5.732-2.293-5.732-2.293" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="Cinema4dIcon_svg__e"><path d="M35.561 24.171c-.252 3.218-.886 5.622-1.754 7.409a8.31 8.31 0 0 1-8.446 5.169c-3.998-.347-7.236-3.62-7.543-7.622a8.3 8.3 0 0 1 3.718-7.596c1.982-1.462 4.762-2.042 7.147-2.518 1.933-.386 2.888-.969 3.305-1.569.41-.592.093-1.417-.58-1.674a11.6 11.6 0 0 0-5.019-.738c-6.157.453-11 5.765-10.887 11.938.123 6.754 5.945 12.116 12.86 11.481 5.261-.484 9.616-4.54 10.476-9.75a11.67 11.67 0 0 0-.719-6.386c-.37-.902-1.64-.985-2.081-.113-.337.667-.446 1.561-.478 1.971" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="Cinema4dIcon_svg__f"><path d="M15.5 15h23.499v23.5H15.5z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#Cinema4dIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#Cinema4dIcon_svg__b);"><path d="M16.219 14.573h23.207v24.354H16.219z" style="fill:#616161;"></path></g><g style="clip-path:url(#Cinema4dIcon_svg__c);"><path d="M20.231 15.091h19.195v18.64H20.231z" style="fill:#212121;"></path></g><g style="clip-path:url(#Cinema4dIcon_svg__d);"><path d="M23.021 15.719h15.26v15.364h-15.26z" style="fill:#3949ab;"></path></g><g style="clip-path:url(#Cinema4dIcon_svg__e);"><g style="clip-path:url(#Cinema4dIcon_svg__f);"><path d="M14.5 14h25.499v25.5H14.5z" style="fill:#e0e0e0;"></path></g></g>', 7)
  ])]);
}
const bl = { render: Ml }, Al = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function wl(l, e) {
  return s(), c("svg", Al, [...e[0] || (e[0] = [
    b('<defs><clipPath id="DavinciResolveIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="DavinciResolveIcon_svg__b"><path d="M27.5 15.6c-6.296 0-11.4 5.104-11.4 11.4s5.104 11.4 11.4 11.4S38.9 33.296 38.9 27s-5.104-11.4-11.4-11.4" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__c"><path d="m28.138 27.7 1.445 3.798c.329.445.718.834 1.182 1.097 1.451.824 3.3.349 4.129-1.061-.001 0-6.59-3.708-6.756-3.834" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__d"><path d="M28.138 27.7c.193.077 6.756 3.834 6.756 3.834.828-1.411.322-3.222-1.129-4.045-.466-.264-1.002-.401-1.558-.457z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__e"><path d="M33.195 28.527a5 5 0 0 0-.558-.262 2.9 2.9 0 0 1-.379 1.774 2.95 2.95 0 0 1-1.372 1.208c.166.127.334.245.509.344 1.819 1.032 3.001.788 3.498-.058s.121-1.975-1.698-3.007" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__f"><path d="M29.698 30.08c.353.426.754.835 1.188 1.168a2.97 2.97 0 0 0 1.373-1.21 2.87 2.87 0 0 0 .379-1.772 7.6 7.6 0 0 0-1.622-.428c.026.444-.072.901-.316 1.316a2.37 2.37 0 0 1-1.002.926" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__g"><path d="M30.887 31.248a7.5 7.5 0 0 1-1.188-1.166 2.4 2.4 0 0 1-.806.23c.191.409.419.817.692 1.188.449.01.894-.072 1.302-.252" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__h"><path d="M31.015 27.838a7.7 7.7 0 0 1 1.622.427 2.9 2.9 0 0 0-.431-1.235 7 7 0 0 0-1.392.006c.113.254.184.524.2.802" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__i"><path d="M30.7 29.154c.244-.415.342-.871.314-1.316-1.483-.236-2.876-.138-2.876-.138s.61 1.236 1.56 2.381a2.37 2.37 0 0 0 1.002-.926" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__j"><path d="M29.698 30.08c-.95-1.145-1.56-2.381-1.56-2.381a.28.28 0 0 0-.032.204c.091.445.33 1.427.786 2.408.28-.032.554-.107.806-.232" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__k"><path d="M30.816 27.037a12 12 0 0 0-2.515.535.3.3 0 0 0-.161.128s1.393-.098 2.876.138a2.4 2.4 0 0 0-.2-.802" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__l"><path d="M26.853 27.7c-.166.126-6.755 3.834-6.755 3.834.829 1.41 2.677 1.885 4.129 1.061.464-.264.853-.652 1.181-1.097z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__m"><path d="m26.853 27.7-4.069-.668c-.556.056-1.093.193-1.556.457-1.452.823-1.958 2.634-1.13 4.045.001 0 6.563-3.756 6.756-3.834" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__n"><path d="M23.596 31.592a4.5 4.5 0 0 0 .509-.343 2.95 2.95 0 0 1-1.372-1.21 2.87 2.87 0 0 1-.379-1.772 5 5 0 0 0-.558.26c-1.818 1.032-2.195 2.16-1.698 3.007.498.846 1.68 1.09 3.498.058" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__o"><path d="M23.976 27.838a7.7 7.7 0 0 0-1.622.427c-.062.596.05 1.214.379 1.774.328.558.816.964 1.372 1.208a7.5 7.5 0 0 0 1.189-1.166 2.37 2.37 0 0 1-1.002-.926 2.3 2.3 0 0 1-.316-1.316" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__p"><path d="M22.354 28.266a7.6 7.6 0 0 1 1.622-.427c.017-.277.088-.547.199-.802a7 7 0 0 0-1.391-.006 2.9 2.9 0 0 0-.431 1.235" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__q"><path d="M25.294 30.08a7.5 7.5 0 0 1-1.188 1.168c.408.179.853.262 1.303.251.272-.37.5-.779.691-1.188a2.4 2.4 0 0 1-.806-.23" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__r"><path d="M24.292 29.154c.244.415.596.726 1.002.926.95-1.145 1.56-2.381 1.56-2.381s-1.394-.098-2.878.138c-.026.445.072.901.316 1.316" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__s"><path d="M23.976 27.838c1.483-.236 2.876-.138 2.876-.138a.3.3 0 0 0-.162-.128 12 12 0 0 0-2.514-.535 2.3 2.3 0 0 0-.2.802" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__t"><path d="M26.1 30.311c.456-.982.694-1.962.786-2.408a.3.3 0 0 0-.032-.203s-.61 1.236-1.56 2.38c.253.126.526.2.806.232" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__u"><path d="M37.922 29.792a10.7 10.7 0 0 1-1.076 2.604l1.039.599c.52-.898.92-1.867 1.195-2.893z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__v"><path d="m19.863 34.637-.848.848a12 12 0 0 0 2.49 1.9l.599-1.039a10.8 10.8 0 0 1-2.24-1.709" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__w"><path d="M16.7 27h-1.2c0 1.075.155 2.112.42 3.103l1.158-.311A10.8 10.8 0 0 1 16.7 27" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__x"><path d="m18.154 32.396-1.039.599a12 12 0 0 0 1.9 2.49l.848-.848a10.9 10.9 0 0 1-1.709-2.24" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__y"><path d="m17.078 29.792-1.158.311a12 12 0 0 0 1.195 2.893l1.039-.6a10.7 10.7 0 0 1-1.076-2.604" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__z"><path d="m22.104 36.346-.599 1.039c.898.518 1.867.92 2.892 1.195l.311-1.158a10.7 10.7 0 0 1-2.604-1.076" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__A"><path d="m32.896 36.346.599 1.039a12 12 0 0 0 2.49-1.9l-.848-.848a10.9 10.9 0 0 1-2.24 1.709" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__B"><path d="m30.292 37.422.31 1.158a12 12 0 0 0 2.893-1.195l-.599-1.039a10.7 10.7 0 0 1-2.604 1.076" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__C"><path d="m35.137 34.637.848.848a12 12 0 0 0 1.9-2.49l-1.039-.599a10.8 10.8 0 0 1-1.709 2.24" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__D"><path d="m24.708 37.422-.31 1.158c.99.265 2.027.42 3.102.42v-1.2c-.967 0-1.901-.139-2.792-.378" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__E"><path d="M27.5 37.8V39c1.075 0 2.112-.155 3.103-.42l-.311-1.158c-.893.239-1.825.378-2.792.378" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__F"><path d="m24.708 16.578-.311-1.158a12 12 0 0 0-2.893 1.195l.6 1.039a10.7 10.7 0 0 1 2.604-1.076" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__G"><path d="m37.922 24.208 1.158-.31a12 12 0 0 0-1.195-2.893l-1.039.599c.468.808.83 1.681 1.076 2.604" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__H"><path d="m36.846 21.604 1.039-.599a12 12 0 0 0-1.9-2.49l-.848.848a10.9 10.9 0 0 1 1.709 2.24" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__I"><path d="m35.137 19.363.848-.848a12 12 0 0 0-2.49-1.9l-.599 1.039a10.8 10.8 0 0 1 2.24 1.709" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__J"><path d="m32.896 17.654.599-1.039a11.8 11.8 0 0 0-2.892-1.195l-.31 1.158c.922.246 1.795.608 2.603 1.076" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__K"><path d="M38.3 27h1.2c0-1.075-.155-2.112-.42-3.103l-1.158.311c.239.893.378 1.825.378 2.792" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__L"><path d="m17.078 24.208-1.158-.311c-.265.991-.42 2.028-.42 3.103h1.2c0-.967.139-1.901.378-2.792" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__M"><path d="m37.922 29.792 1.158.31c.265-.99.42-2.027.42-3.102h-1.2c0 .967-.139 1.901-.378 2.792" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__N"><path d="m30.292 16.578.31-1.158A12 12 0 0 0 27.5 15v1.2c.967 0 1.901.139 2.792.378" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__O"><path d="m19.863 19.363-.848-.848a12 12 0 0 0-1.9 2.49l1.039.599a10.8 10.8 0 0 1 1.709-2.24" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__P"><path d="m18.154 21.604-1.039-.599c-.52.896-.922 1.867-1.195 2.892l1.158.31c.246-.922.608-1.795 1.076-2.603" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__Q"><path d="m22.104 17.654-.599-1.039a12 12 0 0 0-2.49 1.9l.848.848a10.9 10.9 0 0 1 2.24-1.709" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__R"><path d="M27.5 16.2V15c-1.075 0-2.112.155-3.103.42l.311 1.158A10.8 10.8 0 0 1 27.5 16.2" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__S"><path d="M27.501 19.2V27a.28.28 0 0 0 .193-.076c.666-.587 2.806-2.639 2.806-4.69 0-1.676-1.343-3.034-2.999-3.035" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__T"><path d="M27.5 19.2s-.001 0 0 0c-1.656 0-3 1.358-3 3.035 0 2.051 2.14 4.103 2.806 4.69.056.05.126.076.194.076v-7.8Z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__U"><path d="M27.5 19.2c-.995 0-1.8.9-1.8 3 0 2.154 1.8 4.8 1.8 4.8s1.8-2.646 1.8-4.8c0-2.1-.805-3-1.8-3" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__V"><path d="M27.5 19.2c.325 0 .565.055.599.064 1.034.235 1.801 1.06 1.801 2.036 0 .546-.246 1.044-.636 1.416.006-.042-1.595-3.498-1.764-3.516" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__W"><path d="M28.592 24.996C28.088 26.136 27.5 27 27.5 27s-.588-.864-1.092-2.004a3.02 3.02 0 0 0 2.184 0" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__X"><path d="M25.736 22.716A1.93 1.93 0 0 1 25.1 21.3c0-1.014.822-1.86 1.914-2.058.096-.018.384-.042.486-.042-.906.108-1.788 3.342-1.764 3.516" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__Y"><path d="M29.3 22.2c0 .084 0 .174-.012.258 0 .084-.012.174-.024.258-.438.42-1.068.684-1.764.684s-1.326-.264-1.764-.684a4 4 0 0 1-.036-.516c0-1.968.708-2.88 1.614-2.988.06-.012.126-.012.186-.012s.126 0 .186.012c.168.018.336.066.486.15q.072.037.144.084.072.043.144.114.065.053.12.114c.138.144.264.324.36.546q.046.099.084.198.043.106.078.222.036.1.054.21c.024.096.048.192.06.294.024.114.042.24.054.366.018.21.03.444.03.69" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__Z"><path d="M30.488 22.47c-.15 1.974-2.154 3.894-2.796 4.458A.28.28 0 0 1 27.5 27s.588-.864 1.092-2.004a3.03 3.03 0 0 0 1.896-2.526" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="DavinciResolveIcon_svg__aa"><path d="M27.5 27a.28.28 0 0 1-.192-.072c-.642-.564-2.646-2.484-2.796-4.458a3.03 3.03 0 0 0 1.896 2.526C26.912 26.136 27.5 27 27.5 27" style="clip-rule:evenodd;fill:none;"></path></clipPath></defs><g style="clip-path:url(#DavinciResolveIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#DavinciResolveIcon_svg__b);"><path d="M15.1 14.6h24.8v24.8H15.1z" style="fill:#37474f;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__c);"><path d="M27.138 26.7h8.756v7.719h-8.756z" style="fill:#ff7043;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__d);"><path d="M27.138 26.032h9.584v6.502h-9.584z" style="fill:#f16461;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__e);"><path d="M29.886 27.265h6.504v6.358h-6.504z" style="fill:#ff5252;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__f);"><path d="M28.698 26.838H33.7v5.41h-5.002z" style="fill:#ff855f;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__g);"><path d="M27.893 29.082h3.994v3.428h-3.994z" style="fill:#ff8a65;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__h);"><path d="M29.815 25.984h3.823v3.282h-3.823z" style="fill:#ff8a80;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__i);"><path d="M27.138 26.601h4.904v4.479h-4.904z" style="fill:#ffccbc;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__j);"><path d="M27.09 26.7h3.608v4.612H27.09z" style="fill:#ffab91;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__k);"><path d="M27.14 26.037h4.876v2.802H27.14z" style="fill:#ffcdd2;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__l);"><path d="M19.098 26.7h8.755v7.719h-8.755z" style="fill:#c6cf47;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__m);"><path d="M18.269 26.032h9.584v6.502h-9.584z" style="fill:#e1eb8a;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__n);"><path d="M18.602 27.267h6.504v6.357h-6.504z" style="fill:#dce775;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__o);"><path d="M21.291 26.838h5.002v5.409h-5.002z" style="fill:#fff59d;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__p);"><path d="M21.354 25.984h3.822v3.282h-3.822z" style="fill:#e6ee9c;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__q);"><path d="M23.106 29.08H27.1v3.429h-3.994z" style="fill:#ffd740;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__r);"><path d="M22.95 26.601h4.904v4.479H22.95z" style="fill:#fff9c4;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__s);"><path d="M22.976 26.037h4.876v2.802h-4.876z" style="fill:#f0f4c3;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__t);"><path d="M24.293 26.7H27.9v4.611h-3.607z" style="fill:#ffe082;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__u);"><path d="M35.846 28.792h4.234v5.203h-4.234z" style="fill:#f44336;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__v);"><path d="M18.015 33.637h5.089v4.748h-5.089z" style="fill:#ffd740;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__w);"><path d="M14.5 26h3.578v5.103H14.5z" style="fill:#aed581;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__x);"><path d="M16.115 31.396h4.748v5.089h-4.748z" style="fill:#fff176;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__y);"><path d="M14.92 28.792h4.234v5.204H14.92z" style="fill:#dce775;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__z);"><path d="M20.505 35.346h5.203v4.234h-5.203z" style="fill:#ffca28;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__A);"><path d="M31.896 33.637h5.089v4.748h-5.089z" style="fill:#ff7043;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__B);"><path d="M29.292 35.346h5.203v4.234h-5.203z" style="fill:#fb8c00;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__C);"><path d="M34.137 31.396h4.748v5.089h-4.748z" style="fill:#ff5252;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__D);"><path d="M23.398 36.422H28.5V40h-5.102z" style="fill:#ffb74d;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__E);"><path d="M26.5 36.422h5.103V40H26.5z" style="fill:#ffa726;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__F);"><path d="M20.504 14.42h5.204v4.234h-5.204z" style="fill:#64b5f6;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__G);"><path d="M35.846 20.005h4.234v5.203h-4.234z" style="fill:#9575cd;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__H);"><path d="M34.137 17.515h4.748v5.089h-4.748z" style="fill:#7986cb;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__I);"><path d="M31.896 15.615h5.089v4.748h-5.089z" style="fill:#8c9eff;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__J);"><path d="M29.293 14.42h5.202v4.234h-5.202z" style="fill:#82b1ff;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__K);"><path d="M36.922 22.897H40.5V28h-3.578z" style="fill:#f06292;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__L);"><path d="M14.5 22.897h3.578V28H14.5z" style="fill:#9ccc65;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__M);"><path d="M36.922 26H40.5v5.102h-3.578z" style="fill:#ef5350;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__N);"><path d="M26.5 14h5.102v3.578H26.5z" style="fill:#64b5f6;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__O);"><path d="M16.115 17.515h4.748v5.089h-4.748z" style="fill:#68c1b8;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__P);"><path d="M14.92 20.005h4.234v5.202H14.92z" style="fill:#81c784;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__Q);"><path d="M18.015 15.615h5.089v4.748h-5.089z" style="fill:#4db6ac;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__R);"><path d="M23.397 14H28.5v3.578h-5.103z" style="fill:#4ba9f5;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__S);"><path d="M26.499 18.2h5V28h-5z" style="fill:#7986cb;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__T);"><path d="M23.5 18.2h5V28h-5z" style="fill:#26a69a;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__U);"><path d="M24.7 18.2h5.6V28h-5.6z" style="fill:#82b1ff;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__V);"><path d="M26.5 18.2h4.4v5.516h-4.4z" style="fill:#4db6ac;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__W);"><path d="M25.408 23.996h4.184V28h-4.184z" style="fill:#90caf9;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__X);"><path d="M24.1 18.2h4.4v5.516h-4.4z" style="fill:#8dd0ca;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__Y);"><path d="M24.7 18.2h5.6v6.2h-5.6z" style="fill:#80cbc4;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__Z);"><path d="M26.5 21.47h4.988V28H26.5z" style="fill:#9fa8da;"></path></g><g style="clip-path:url(#DavinciResolveIcon_svg__aa);"><path d="M23.512 21.47H28.5V28h-4.988z" style="fill:#81c784;"></path></g>', 55)
  ])]);
}
const zl = { render: wl }, kl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Sl(l, e) {
  return s(), c("svg", kl, [...e[0] || (e[0] = [
    b('<defs><clipPath id="MSAccessIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="MSAccessIcon_svg__b"><path d="M21.833 29.75v5.5c0 1.518 3.694 2.75 8.25 2.75s8.25-1.231 8.25-2.75v-5.5z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSAccessIcon_svg__c"><path d="M21.833 24.25v5.5c0 1.519 3.694 2.75 8.25 2.75s8.25-1.231 8.25-2.75v-5.5z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSAccessIcon_svg__d"><path d="M21.833 18.75v5.5c0 1.519 3.694 2.75 8.25 2.75s8.25-1.231 8.25-2.75v-5.5z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSAccessIcon_svg__e"><path d="M30.083 16c-4.556 0-8.25 1.231-8.25 2.75s3.694 2.75 8.25 2.75 8.25-1.231 8.25-2.75S34.64 16 30.083 16" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSAccessIcon_svg__f"><path d="M27.598 26.872v-4.093a1.023 1.023 0 0 0-1.019-1.019h-4.746v2.49c0 1.229 2.424 2.271 5.765 2.623" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSAccessIcon_svg__g"><path d="M21.833 24.25v5.5c0 1.231 2.424 2.271 5.765 2.622v-5.5c-3.342-.351-5.765-1.392-5.765-2.622" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSAccessIcon_svg__h"><path d="M21.833 29.75v4.235h4.546a1.31 1.31 0 0 0 1.22-1.182v-.431c-3.342-.351-5.765-1.392-5.765-2.622" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSAccessIcon_svg__i"><path d="M25.695 33.108H15.527c-.567 0-1.028-.46-1.028-1.027V21.912c0-.566.461-1.027 1.028-1.027h10.168c.567 0 1.027.461 1.027 1.027v10.169c0 .567-.46 1.027-1.027 1.027" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSAccessIcon_svg__j"><path d="M14.5 20.886h12.222v12.222H14.5z" style="fill:none;"></path></clipPath><clipPath id="MSAccessIcon_svg__k"><path d="M19.952 23.945h1.385l2.226 6.111h-1.309l-.49-1.458h-2.289l-.482 1.458h-1.299l2.259-6.111Zm1.518 3.711-.713-2.211a3 3 0 0 1-.132-.499h-.026q-.041.26-.127.511l-.721 2.199z" style="clip-rule:evenodd;fill:none;"></path></clipPath></defs><g style="clip-path:url(#MSAccessIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#MSAccessIcon_svg__b);"><path d="M20.833 28.75h18.5V39h-18.5z" style="fill:#881421;"></path></g><g style="clip-path:url(#MSAccessIcon_svg__c);"><path d="M20.833 23.25h18.5V33.5h-18.5z" style="fill:#af2031;"></path></g><g style="clip-path:url(#MSAccessIcon_svg__d);"><path d="M20.833 17.75h18.5V28h-18.5z" style="fill:#c94f60;"></path></g><g style="clip-path:url(#MSAccessIcon_svg__e);"><path d="M20.833 15h18.5v7.5h-18.5z" style="fill:#e08095;"></path></g><g style="clip-path:url(#MSAccessIcon_svg__f);"><path d="M20.833 20.76h7.765v7.113h-7.765z" style="fill:#993c49;"></path></g><g style="clip-path:url(#MSAccessIcon_svg__g);"><path d="M20.833 23.25h7.765v10.122h-7.765z" style="fill:#941b29;"></path></g><g style="clip-path:url(#MSAccessIcon_svg__h);"><path d="M20.833 28.75h7.765v6.235h-7.765z" style="fill:#6e101b;"></path></g><g style="clip-path:url(#MSAccessIcon_svg__i);"><g style="clip-path:url(#MSAccessIcon_svg__j);"><path d="M13.5 19.886h14.222v14.222H13.5z" style="fill:#af2031;"></path></g></g><g style="clip-path:url(#MSAccessIcon_svg__k);"><path d="M16.694 22.945h7.869v8.111h-7.869z" style="fill:#fff;"></path></g>', 12)
  ])]);
}
const Dl = { render: Sl }, Cl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Rl(l, e) {
  return s(), c("svg", Cl, [...e[0] || (e[0] = [
    b('<defs><clipPath id="MSExcelIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="MSExcelIcon_svg__b"><path d="M29.5 16h-7.954c-.577 0-1.046.478-1.046 1.066v4.435h9z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__c"><path d="M20.5 32.533v4.401c0 .589.469 1.066 1.046 1.066H29.5v-5.467z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__d"><path d="M14.5 16h24v22h-24z" style="fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__e"><path d="M14 16h25v22H14z" style="fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__f"><path d="M20.5 21.501h9v5.501h-9z" style="fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__g"><path d="M20.5 27.004h9v5.531h-9z" style="fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__h"><path d="M37.454 16H29.5v5.501h9v-4.435c0-.588-.469-1.066-1.046-1.066" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__i"><path d="M14 16h25v22H14z" style="fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__j"><path d="M29.5 32.533V38h7.954c.577 0 1.046-.477 1.046-1.065v-4.401h-9Z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__k"><path d="M14 16h25v22H14z" style="fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__l"><path d="M29.5 21.501h9v5.501h-9z" style="fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__m"><path d="M29.5 27.004h9v5.531h-9z" style="fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__n"><path d="M25.491 33.111h-9.983c-.557 0-1.009-.46-1.009-1.027V21.915c0-.567.452-1.027 1.009-1.027h9.983c.557 0 1.008.46 1.008 1.027v10.169c0 .567-.451 1.027-1.008 1.027" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__o"><path d="M14 16h25v22H14z" style="fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__p"><path d="M17.984 23.944h1.432l1.161 2.295 1.228-2.295h1.337L21.3 27l1.884 3.056h-1.41l-1.266-2.402-1.261 2.402h-1.432l1.916-3.067z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSExcelIcon_svg__q"><path d="M14 16h25v22H14z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#MSExcelIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#MSExcelIcon_svg__b);"><path d="M19.5 15h11v7.501h-11z" style="fill:#169154;"></path></g><g style="clip-path:url(#MSExcelIcon_svg__c);"><path d="M19.5 31.533h11V39h-11z" style="fill:#18482a;"></path></g><g style="clip-path:url(#MSExcelIcon_svg__d);"><g style="isolation:isolate;"><g style="clip-path:url(#MSExcelIcon_svg__e);"><g style="clip-path:url(#MSExcelIcon_svg__f);"><path d="M19.5 20.501h11v7.501h-11z" style="fill:#0c8045;"></path></g><g style="clip-path:url(#MSExcelIcon_svg__g);"><path d="M19.5 26.004h11v7.531h-11z" style="fill:#17472a;"></path></g><g style="clip-path:url(#MSExcelIcon_svg__h);"><g style="clip-path:url(#MSExcelIcon_svg__i);"><path d="M28.5 15h11v7.501h-11z" style="fill:#29c27f;"></path></g></g><g style="clip-path:url(#MSExcelIcon_svg__j);"><g style="clip-path:url(#MSExcelIcon_svg__k);"><path d="M28.5 31.533h11V39h-11z" style="fill:#27663f;"></path></g></g><g style="clip-path:url(#MSExcelIcon_svg__l);"><path d="M28.5 20.501h11v7.501h-11z" style="fill:#19ac65;"></path></g><g style="clip-path:url(#MSExcelIcon_svg__m);"><path d="M28.5 26.004h11v7.531h-11z" style="fill:#129652;"></path></g><g style="clip-path:url(#MSExcelIcon_svg__n);"><g style="clip-path:url(#MSExcelIcon_svg__o);"><path d="M13.499 19.889h14v14.222h-14z" style="fill:#0c7238;"></path></g></g><g style="clip-path:url(#MSExcelIcon_svg__p);"><g style="clip-path:url(#MSExcelIcon_svg__q);"><path d="M16.815 22.944h7.369v8.111h-7.369z" style="fill:#fff;"></path></g></g></g></g></g>', 6)
  ])]);
}
const El = { render: Rl }, Vl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Bl(l, e) {
  return s(), c("svg", Vl, [...e[0] || (e[0] = [
    b('<defs><clipPath id="MSPublisherIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="MSPublisherIcon_svg__b"><path d="M37.492 35.556H27.1V18.445h10.392c.557 0 1.008.46 1.008 1.027V34.53c0 .567-.451 1.027-1.008 1.027" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSPublisherIcon_svg__c"><path d="M35.501 31.889v5.048c0 .588-.467 1.063-1.044 1.063H20.945a1.053 1.053 0 0 1-1.044-1.063v-5.048l7.8-1.222z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSPublisherIcon_svg__d"><path d="M35.501 26.389v5.5H19.9v-5.5l7.2-1.833z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSPublisherIcon_svg__e"><path d="M35.501 17.063v9.326h-15.6v-9.326c0-.587.468-1.063 1.044-1.063h13.512c.576 0 1.044.477 1.044 1.063" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSPublisherIcon_svg__f"><path d="M25.492 33.111h-9.983a1.02 1.02 0 0 1-1.009-1.027V21.915c0-.567.452-1.027 1.009-1.027h9.983c.557 0 1.008.459 1.008 1.027v10.169c0 .567-.451 1.027-1.008 1.027" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSPublisherIcon_svg__g"><path d="M14.5 20.889h12v12.222h-12z" style="fill:none;"></path></clipPath><clipPath id="MSPublisherIcon_svg__h"><path d="M20.995 23.944h-2.804v6.111h1.214v-2.152h1.366c1.126 0 2.039-.929 2.039-2.075v-.035c-.001-1.021-.814-1.848-1.814-1.848Zm.538 2.045a.944.944 0 0 1-.934.951h-1.194v-2.033h1.194c.515 0 .934.427.934.951z" style="clip-rule:evenodd;fill:none;"></path></clipPath></defs><g style="clip-path:url(#MSPublisherIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#MSPublisherIcon_svg__b);"><path d="M26.1 17.444h13.4v19.111H26.1z" style="fill:#006064;"></path></g><g style="clip-path:url(#MSPublisherIcon_svg__c);"><path d="M18.9 29.667h17.6V39H18.9z" style="fill:#00838f;"></path></g><g style="clip-path:url(#MSPublisherIcon_svg__d);"><path d="M18.9 23.556h17.6v9.333H18.9z" style="fill:#0097a7;"></path></g><g style="clip-path:url(#MSPublisherIcon_svg__e);"><path d="M18.9 15h17.6v12.389H18.9z" style="fill:#26c6da;"></path></g><g style="clip-path:url(#MSPublisherIcon_svg__f);"><g style="clip-path:url(#MSPublisherIcon_svg__g);"><path d="M13.5 19.889h14v14.222h-14z" style="fill:#006064;"></path></g></g><g style="clip-path:url(#MSPublisherIcon_svg__h);"><path d="M17.191 22.944h6.619v8.111h-6.619z" style="fill:#fff;"></path></g>', 9)
  ])]);
}
const Hl = { render: Bl }, $l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Fl(l, e) {
  return s(), c("svg", $l, [...e[0] || (e[0] = [
    b('<defs><clipPath id="MSWordIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="MSWordIcon_svg__b"><path d="M36.954 16H21.047c-.578 0-1.046.478-1.046 1.066v4.435h18v-4.435c0-.588-.469-1.066-1.046-1.066" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSWordIcon_svg__c"><path d="M20 32.533v4.401c0 .589.469 1.066 1.046 1.066h15.907c.577 0 1.046-.477 1.046-1.066v-4.401z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSWordIcon_svg__d"><path d="M14 16h24v22H14z" style="fill:none;"></path></clipPath><clipPath id="MSWordIcon_svg__e"><path d="M13 20h25v14H13z" style="fill:none;"></path></clipPath><clipPath id="MSWordIcon_svg__f"><path d="M20 21.501h18v5.501H20z" style="fill:none;"></path></clipPath><clipPath id="MSWordIcon_svg__g"><path d="M20 27.004h18v5.531H20z" style="fill:none;"></path></clipPath><clipPath id="MSWordIcon_svg__h"><path d="M24.991 33.111h-9.983a1.02 1.02 0 0 1-1.009-1.027V21.915c0-.567.452-1.027 1.009-1.027h9.983c.557 0 1.008.459 1.008 1.027v10.169c0 .567-.451 1.027-1.008 1.027" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSWordIcon_svg__i"><path d="M14 16h24v22H14z" style="fill:none;"></path></clipPath><clipPath id="MSWordIcon_svg__j"><path d="m22.642 23.944-.928 4.44-1.028-4.44h-1.312l-1.061 4.578-.955-4.578h-1.173l1.406 6.112h1.411l1.027-4.699 1.029 4.699h1.351l1.406-6.112z" style="clip-rule:evenodd;fill:none;"></path></clipPath><clipPath id="MSWordIcon_svg__k"><path d="M14 16h24v22H14z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#MSWordIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#MSWordIcon_svg__b);"><path d="M19 15h20v7.501H19z" style="fill:#2d92d4;"></path></g><g style="clip-path:url(#MSWordIcon_svg__c);"><path d="M19 31.533h20V39H19z" style="fill:#2150a9;"></path></g><g style="clip-path:url(#MSWordIcon_svg__d);"><g style="isolation:isolate;"><g style="clip-path:url(#MSWordIcon_svg__e);"><g style="clip-path:url(#MSWordIcon_svg__f);"><path d="M19 20.501h20v7.501H19z" style="fill:#2d83d4;"></path></g><g style="clip-path:url(#MSWordIcon_svg__g);"><path d="M19 26.004h20v7.53H19z" style="fill:#2e70c9;"></path></g><g style="clip-path:url(#MSWordIcon_svg__h);"><g style="clip-path:url(#MSWordIcon_svg__i);"><path d="M13 19.889h13.999v14.222H13z" style="fill:#00488d;"></path></g></g><g style="clip-path:url(#MSWordIcon_svg__j);"><g style="clip-path:url(#MSWordIcon_svg__k);"><path d="M15.185 22.944h9.631v8.111h-9.631z" style="fill:#fff;"></path></g></g></g></g></g>', 6)
  ])]);
}
const Ul = { render: Fl }, ql = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Tl(l, e) {
  return s(), c("svg", ql, [...e[0] || (e[0] = [
    b('<defs><clipPath id="VectorIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="VectorIcon_svg__b"><path d="M28.212 19.514a.75.75 0 0 1 1.134.977l-.073.084-8.198 8.198a.75.75 0 0 1-1.134-.977l.073-.084z" style="fill:none;"></path></clipPath><clipPath id="VectorIcon_svg__c"><path d="M30.357 16.893a1.536 1.536 0 1 1 0 3.073 1.536 1.536 0 0 1 0-3.073m0-1.5a3.037 3.037 0 0 0 0 6.072 3.037 3.037 0 0 0 0-6.072" style="fill:none;"></path></clipPath><clipPath id="VectorIcon_svg__d"><path d="M18.929 28.321a1.537 1.537 0 0 1 0 3.072 1.536 1.536 0 0 1 0-3.072m0-1.5a3.037 3.037 0 0 0 0 6.072 3.037 3.037 0 0 0 0-6.072" style="fill:none;"></path></clipPath><clipPath id="VectorIcon_svg__e"><path d="M33.786 25.679a.75.75 0 0 1 .102 1.493l-.102.007h-3.048a3.06 3.06 0 0 0-3.054 2.865l-.006.179v3.048a.75.75 0 0 1-1.493.102l-.007-.102V30.22a4.56 4.56 0 0 1 4.345-4.536l.214-.005h3.048Z" style="fill:none;"></path></clipPath><clipPath id="VectorIcon_svg__f"><path d="M15.5 15h24v24h-24z" style="fill:none;"></path></clipPath><clipPath id="VectorIcon_svg__g"><path d="M23 23h17v16H23z" style="fill:none;"></path></clipPath><clipPath id="VectorIcon_svg__h"><path d="M37.607 24.892v3.072h-3.072v-3.072zm1.5-1.499h-6.071v6.071h6.071z" style="fill:none;"></path></clipPath><clipPath id="VectorIcon_svg__i"><path d="M15 15h25v24H15z" style="fill:none;"></path></clipPath><clipPath id="VectorIcon_svg__j"><path d="M28.464 34.035v3.072h-3.072v-3.072zm1.5-1.499h-6.071v6.071h6.071z" style="fill:none;"></path></clipPath><clipPath id="VectorIcon_svg__k"><path d="M15 15h25v24H15z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#VectorIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#VectorIcon_svg__b);"><path d="M18.723 18.221h11.84v11.844h-11.84z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#VectorIcon_svg__c);"><path d="M26.321 14.393h8.072v8.071h-8.072z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#VectorIcon_svg__d);"><path d="M14.893 25.821h8.071v8.072h-8.071z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#VectorIcon_svg__e);"><path d="M25.179 24.679h10.357v10.342H25.179z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#VectorIcon_svg__f);"><g style="isolation:isolate;"><g style="clip-path:url(#VectorIcon_svg__g);"><g style="clip-path:url(#VectorIcon_svg__h);"><g style="clip-path:url(#VectorIcon_svg__i);"><path d="M32.036 22.393h8.071v8.071h-8.071z" style="fill:#2d2d2d;"></path></g></g><g style="clip-path:url(#VectorIcon_svg__j);"><g style="clip-path:url(#VectorIcon_svg__k);"><path d="M22.893 31.536h8.071v8.071h-8.071z" style="fill:#2d2d2d;"></path></g></g></g></g></g>', 8)
  ])]);
}
const Wl = { render: Tl }, Ll = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function jl(l, e) {
  return s(), c("svg", Ll, [...e[0] || (e[0] = [
    b('<defs><clipPath id="ZipIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;"></rect></clipPath><clipPath id="ZipIcon_svg__b"><path d="M28.75 25.75h-3.166v-3.917a1.58 1.58 0 0 1 1.582-1.583l.144.007a1.585 1.585 0 0 1 1.439 1.577v3.917Zm-4.667 1.5h6.167v-5.417a3.084 3.084 0 0 0-6.166 0v5.417Z" style="fill:none;"></path></clipPath><clipPath id="ZipIcon_svg__c"><path d="M22.25 3.75h4.5v1.5h-4.5z" style="fill:none;"></path></clipPath><clipPath id="ZipIcon_svg__d"><path d="M27.25 5.75h4.5v1.5h-4.5z" style="fill:none;"></path></clipPath><clipPath id="ZipIcon_svg__e"><path d="M22.25 7.75h4.5v1.5h-4.5z" style="fill:none;"></path></clipPath><clipPath id="ZipIcon_svg__f"><path d="M27.25 9.75h4.5v1.5h-4.5z" style="fill:none;"></path></clipPath><clipPath id="ZipIcon_svg__g"><path d="M22.25 11.75h4.5v1.5h-4.5z" style="fill:none;"></path></clipPath><clipPath id="ZipIcon_svg__h"><path d="M27.25 13.75h4.5v1.5h-4.5z" style="fill:none;"></path></clipPath><clipPath id="ZipIcon_svg__i"><path d="M22.25 15.75h4.5v1.5h-4.5z" style="fill:none;"></path></clipPath></defs><g style="clip-path:url(#ZipIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#ZipIcon_svg__b);"><path d="M23.083 17.75h8.167v10.5h-8.167z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#ZipIcon_svg__c);"><path d="M21.25 2.75h6.5v3.5h-6.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#ZipIcon_svg__d);"><path d="M26.25 4.75h6.5v3.5h-6.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#ZipIcon_svg__e);"><path d="M21.25 6.75h6.5v3.5h-6.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#ZipIcon_svg__f);"><path d="M26.25 8.75h6.5v3.5h-6.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#ZipIcon_svg__g);"><path d="M21.25 10.75h6.5v3.5h-6.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#ZipIcon_svg__h);"><path d="M26.25 12.75h6.5v3.5h-6.5z" style="fill:#2d2d2d;"></path></g><g style="clip-path:url(#ZipIcon_svg__i);"><path d="M21.25 14.75h6.5v3.5h-6.5z" style="fill:#2d2d2d;"></path></g>', 11)
  ])]);
}
const Ol = { render: jl }, Zl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 54"
};
function Gl(l, e) {
  return s(), c("svg", Zl, [...e[0] || (e[0] = [
    b('<defs><clipPath id="GenericIcon_svg__a"><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke-width:0;"></rect></clipPath><clipPath id="GenericIcon_svg__b"><path d="M37.622 21.419h-3.146A9.3 9.3 0 0 1 36.334 27c0 5.147-4.187 9.334-9.334 9.334S17.666 32.147 17.666 27s4.187-9.334 9.334-9.334c1.021 0 2.003.167 2.923.471v3.282h-2.954c-3.099 0-5.62 2.521-5.62 5.619s2.521 5.62 5.62 5.62 5.619-2.521 5.619-5.62v-7.51l.001.001v-3.148a11.94 11.94 0 0 0-5.59-1.382c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12c0-2.016-.499-3.914-1.378-5.581Zm-7.7 5.62c0 1.629-1.325 2.954-2.954 2.954s-2.954-1.325-2.954-2.954 1.325-2.954 2.954-2.954h2.954z" style="clip-rule:evenodd;fill:none;stroke-width:0;vector-effect:non-scaling-stroke;"></path></clipPath><clipPath id="GenericIcon_svg__c"><path d="M15 15h24v24H15z" style="fill:none;stroke-width:0;vector-effect:non-scaling-stroke;"></path></clipPath></defs><g style="clip-path:url(#GenericIcon_svg__a);"><path d="M6.5 0h41v54h-41z" style="fill:#f8f9fa;stroke-width:0;"></path></g><rect width="39" height="52" x="7.5" y="1" rx="2" ry="2" style="fill:none;stroke:#e2e3e4;stroke-miterlimit:10;vector-effect:non-scaling-stroke;"></rect><g style="clip-path:url(#GenericIcon_svg__b);"><g style="clip-path:url(#GenericIcon_svg__c);"><path d="M14 14h26v26H14z" style="fill:#2d2d2d;stroke-width:0;vector-effect:non-scaling-stroke;"></path></g></g>', 4)
  ])]);
}
const Nl = { render: Gl };
var me = /* @__PURE__ */ ((l) => (l.File = "file", l.Folder = "folder", l))(me || {}), M = /* @__PURE__ */ ((l) => (l.AdobeAfterEffects = "ADOBE_AFTER_EFFECTS", l.AdobeAudition = "ADOBE_AUDITION", l.AdobeIllustrator = "ADOBE_ILLUSTRATOR", l.AdobeIndesign = "ADOBE_INDESIGN", l.AdobePhotoshop = "ADOBE_PHOTOSHOP", l.AdobePremierPro = "ADOBE_PREMIER_PRO", l.Audio = "AUDIO", l.AutodeskAutocad = "AUTODESK_AUTOCAD", l.AutodeskFusion = "AUTODESK_FUSION", l.AutodeskMaya = "AUTODESK_MAYA", l.Cinema_4D = "CINEMA_4D", l.Code = "CODE", l.DavinciResolve = "DAVINCI_RESOLVE", l.Generic = "GENERIC", l.Image = "IMAGE", l.MsAccess = "MS_ACCESS", l.MsExcel = "MS_EXCEL", l.MsPowerPoint = "MS_POWER_POINT", l.MsPublisher = "MS_PUBLISHER", l.MsWord = "MS_WORD", l.Pdf = "PDF", l.Table = "TABLE", l.Text = "TEXT", l.ThreeD = "THREE_D", l.Vector = "VECTOR", l.Video = "VIDEO", l.Zip = "ZIP", l))(M || {});
const Y = {}, X = {
  addUrl(l) {
    Y[l] = !0;
  },
  isImageUrlInCache(l) {
    return !!Y[l];
  },
  isImageSizeCached(l, e) {
    return Object.keys(Y).find((t) => {
      const i = new URL(t), a = `${i.origin}${i.pathname}`, o = new URL(l), p = `${o.origin}${o.pathname}`;
      return a === p && t.toLowerCase().includes(`width=${e}`);
    });
  }
}, Ql = { class: "flex justify-center items-center max-h-[inherit]" }, Kl = ["src"], Ca = /* @__PURE__ */ g({
  __name: "ThumbnailIcon",
  props: {
    iconSize: {},
    type: {},
    imageUrl: {},
    imageSizes: {},
    showShadow: { type: Boolean },
    transition: { type: Boolean }
  },
  setup(l) {
    const e = l, t = u(() => ({
      minWidth: `${e.iconSize}px`,
      maxWidth: `${e.iconSize}px`,
      minHeight: `${e.iconSize}px`,
      maxHeight: `${e.iconSize}px`
    })), i = u(() => ({
      "drop-shadow-[0_4px_5px_rgba(0,0,0,0.05)]": e.showShadow
    })), a = u(() => e.transition ? "fade" : ""), o = y(""), p = y(!1), n = {
      [me.Folder]: It,
      [M.Generic]: Nl,
      [M.Audio]: bt,
      [M.Code]: zt,
      [M.Image]: Dt,
      [M.Pdf]: Et,
      [M.Video]: Ht,
      [M.Text]: Ut,
      [M.MsPowerPoint]: Wt,
      [M.Table]: Ot,
      [M.ThreeD]: Nt,
      [M.AdobeAfterEffects]: Yt,
      [M.AdobeAudition]: el,
      [M.AdobeIllustrator]: al,
      [M.AdobeIndesign]: sl,
      [M.AdobePhotoshop]: rl,
      [M.AdobePremierPro]: dl,
      [M.AutodeskAutocad]: _l,
      [M.AutodeskFusion]: yl,
      [M.AutodeskMaya]: Il,
      [M.Cinema_4D]: bl,
      [M.DavinciResolve]: zl,
      [M.MsAccess]: Dl,
      [M.MsExcel]: El,
      [M.MsPublisher]: Hl,
      [M.MsWord]: Ul,
      [M.Vector]: Wl,
      [M.Zip]: Ol
    }, r = u(() => n[e.type]), h = (d) => {
      const _ = new Image();
      _.onload = () => {
        o.value = d, p.value = !0, X.addUrl(d);
      }, _.src = d;
    }, v = () => {
      if (e.imageUrl && e.imageSizes?.length) {
        if (e.imageUrl.includes("width"))
          throw new Error("ThumbnailIcon with `imageSizes` cannot have a `width` already defined.");
        const d = e.imageSizes.slice().sort((x, C) => C - x), _ = d[0];
        for (const x of d) {
          const C = X.isImageSizeCached(e.imageUrl, x);
          if (C) {
            p.value = !0, o.value = C.toString();
            break;
          }
        }
        const I = new URL(e.imageUrl);
        I.searchParams.append("width", _.toString()), h(I.toString());
      }
      e.imageUrl && !e.imageSizes && (X.isImageUrlInCache(e.imageUrl) ? (o.value = e.imageUrl, p.value = !0) : h(e.imageUrl));
    };
    return N(
      () => e.imageUrl,
      () => {
        v();
      }
    ), Ee(() => {
      v();
    }), (d, _) => (s(), c("div", Ql, [
      $(Ve, {
        name: a.value,
        mode: "out-in"
      }, {
        default: j(() => [
          p.value ? (s(), c("img", {
            key: 0,
            src: o.value,
            class: z(["w-full h-full object-contain overflow-hidden", i.value])
          }, null, 10, Kl)) : (s(), c("div", {
            key: 1,
            class: "flex justify-center items-center mx-auto",
            style: q(t.value)
          }, [
            (s(), Z(Be(r.value), {
              class: z(["w-full min-h-[inherit] max-h-[inherit]", i.value])
            }, null, 8, ["class"]))
          ], 4))
        ]),
        _: 1
      }, 8, ["name"])
    ]));
  }
}), Yl = { class: "shdw w-[254px] pt-2 pb-1 rounded-md bg-white font-secondary z-100 select-none border border-black/8" }, Xl = { class: "flex items-center justify-between mb-1 px-3" }, Jl = {
  key: 0,
  class: "grid grid-cols-7 col-span-2 px-1.5"
}, ea = ["onClick"], ta = {
  key: 1,
  class: "grid grid-cols-3"
}, la = ["onClick"], aa = {
  key: 2,
  class: "grid grid-cols-3"
}, ia = ["onClick"], ne = 1970, na = /* @__PURE__ */ g({
  __name: "Calendar",
  props: {
    modelValue: {},
    startDate: {},
    range: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], i = [
      "January",
      "Febuary",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ], a = l, o = e, p = u(
      () => a.startDate && new Date(a.startDate).toString() !== "Invalid Date" ? new Date(a.startDate) : null
    ), n = ie({
      year: (/* @__PURE__ */ new Date()).getFullYear(),
      month: (/* @__PURE__ */ new Date()).getMonth() + 1,
      date: (/* @__PURE__ */ new Date()).getDate()
    }), r = ie({
      start: null,
      end: null
    });
    if (!a.range && a.modelValue && !Array.isArray(a.modelValue) && (n.year = a.modelValue.getFullYear(), n.month = a.modelValue.getMonth() + 1, n.date = a.modelValue.getDate(), r.start = a.modelValue), a.range && a.modelValue && Array.isArray(a.modelValue)) {
      const P = a.modelValue[1] || a.modelValue[0];
      n.year = P.getFullYear(), n.month = P.getMonth() + 1, n.date = P.getDate(), r.start = a.modelValue[0], r.end = a.modelValue[1] || null;
    }
    const h = y(
      "day"
      /* Day */
    ), v = y(
      "startDate"
      /* Start */
    ), d = u(
      () => h.value === "day"
      /* Day */
    ), _ = u(
      () => h.value === "month"
      /* Month */
    ), I = u(
      () => h.value === "year"
      /* Year */
    ), x = u(() => new Date(n.year, n.month - 1, 1).getDay()), C = u(() => {
      if (d.value) {
        const P = i[n.month - 1], S = n.year;
        return `${P} ${S}`;
      }
      return _.value ? n.year : `${W.value[0]} - ${W.value[W.value.length - 1]}`;
    }), f = u(() => ({
      "grid-column": `span ${x.value}`
    })), V = (P) => {
      const S = new Date(n.year, n.month - 1, P), k = r.start?.toDateString() === S.toDateString(), R = r.end?.toDateString() === S.toDateString(), ae = k || R, ke = p.value && p.value.getMonth() === n.month - 1 && p.value.getFullYear() === n.year ? P < p.value.getDate() : !1, Se = (r.start || 0) < S && new Date(new Date(S).setHours(23, 59, 59, 999)) < (r.end || 0), De = r.start && r.end && r.start.toDateString() !== r.end.toDateString();
      return {
        "date-range": a.range,
        date: !a.range,
        "opacity-50 pointer-events-none": ke,
        "date--selected": !a.range && ae,
        highlight: Se,
        ...De && {
          "highlight--start": !S.getDay(),
          "highlight--end": S.getDay() === 6,
          "date-range--start-highlight": k,
          "date-range--end-highlight": R
        },
        "date-range--start": k,
        "date-range--end": R
      };
    }, T = (P) => ({
      "opacity-50 pointer-events-none": p.value && p.value.getFullYear() === n.year ? P < p.value.getMonth() : !1
    }), xe = (P) => ({
      "opacity-0.5 pointer-events-none": p.value ? P < p.value.getFullYear() : !1
    }), Ie = u(() => new Date(n.year, n.month, 0).getDate()), W = u(() => {
      const P = [], S = Math.ceil((n.year - (ne - 1)) / 12), k = ne - 1 + S * 12;
      for (let R = 0; R < 12; R++)
        P.push(k - R);
      return P.reverse();
    }), Pe = () => {
      if (h.value === "day") {
        const P = n.month - 1 === 0;
        n.month = P ? 12 : n.month - 1, P && (n.year = n.year - 1);
      }
      h.value === "year" && (n.year = W.value[0] - 1);
    }, Me = () => {
      if (h.value === "day") {
        const P = n.month + 1 > 12;
        n.month = P ? 1 : n.month + 1, P && (n.year = n.year + 1);
      }
      h.value === "year" && (n.year = W.value[W.value.length - 1] + 1);
    }, be = (P) => {
      const S = new Date(n.year, n.month - 1, P);
      if (v.value === "endDate" && S >= r.start && (r.end = new Date(S.setHours(23, 59, 59, 999))), (v.value === "startDate" || v.value === "endDate" && S < r.start) && (r.start = S, r.end = null, v.value = "startDate"), a.range && (v.value = v.value === "startDate" ? "endDate" : "startDate"), a.range && r.start && r.end)
        return o("update:modelValue", [r.start, r.end]);
      a.range || o("update:modelValue", r.start);
    }, Ae = (P) => {
      n.month = P + 1, h.value = "day";
    }, we = (P) => {
      n.year = P, h.value = "month";
    }, ze = () => {
      if (h.value === "day") {
        h.value = "month";
        return;
      }
      if (h.value === "month") {
        h.value = "year";
        return;
      }
    };
    return (P, S) => (s(), c("div", Yl, [
      w("div", Xl, [
        _.value ? D("", !0) : (s(), c("div", {
          key: 0,
          class: "flex items-center justify-center cursor-pointer after:content-[''] after:size-6 after:rounded-md after:absolute hover:after:bg-gray-200/35 relative z-1 after:-z-1",
          onClick: Pe
        }, [
          $(H, {
            size: 13,
            name: "ChevronUp",
            class: "stroke-gray-800 -rotate-90"
          })
        ])),
        w("div", {
          class: "px-1.5 text-center text-[14px] leading-[28px] text-gray-800 cursor-pointer font-medium col-span-5 flex items-center justify-center gap-x-1 after:content-[''] after:w-full after:h-6 after:rounded-md after:absolute hover:after:bg-gray-200/35 relative z-1 after:-z-1 mx-auto",
          onClick: ze
        }, [
          Q(E(C.value) + " ", 1),
          $(H, {
            size: 10,
            name: "ChevronUp",
            class: "stroke-gray-400 rotate-180"
          })
        ]),
        _.value ? D("", !0) : (s(), c("div", {
          key: 1,
          class: "flex items-center justify-center cursor-pointer after:content-[''] after:size-6 after:rounded-md after:absolute hover:after:bg-gray-200/35 relative z-1 after:-z-1",
          onClick: Me
        }, [
          $(H, {
            size: 13,
            name: "ChevronUp",
            class: "stroke-gray-800 rotate-90"
          })
        ]))
      ]),
      d.value ? (s(), c("div", Jl, [
        (s(), c(B, null, U(t, (k, R) => w("div", {
          key: R,
          class: "font-medium text-[12px] leading-[32px] text-gray-800/50 flex items-center justify-center"
        }, E(k), 1)), 64)),
        x.value ? (s(), c("div", {
          key: 0,
          style: q(f.value)
        }, null, 4)) : D("", !0),
        (s(!0), c(B, null, U(Ie.value, (k) => (s(), c("div", {
          key: k,
          class: z(["text-[14px] leading-[32px] text-gray-800 flex items-center justify-center cursor-pointer relative z-0", V(k)]),
          onClick: (R) => be(k)
        }, E(k), 11, ea))), 128))
      ])) : D("", !0),
      _.value ? (s(), c("div", ta, [
        (s(), c(B, null, U(i, (k, R) => w("div", {
          key: R,
          class: z(["text-[14px] leading-[44px] text-gray-800 flex items-center justify-center cursor-pointer after:content-[''] after:w-[50px] after:h-8 after:rounded-md after:absolute hover:after:bg-gray-200/35 after:-z-1 z-1", T(R)]),
          onClick: (ae) => Ae(R)
        }, E(k.substring(0, 3)), 11, la)), 64))
      ])) : D("", !0),
      I.value ? (s(), c("div", aa, [
        (s(!0), c(B, null, U(W.value, (k) => (s(), c("div", {
          key: k,
          class: z(["text-[14px] leading-[44px] text-gray-800 flex items-center justify-center cursor-pointer after:content-[''] after:w-[50px] after:h-8 after:rounded-md after:absolute hover:after:bg-gray-200/35 after:-z-1 z-1", xe(k)]),
          onClick: (R) => we(k)
        }, E(k), 11, ia))), 128))
      ])) : D("", !0)
    ]));
  }
}), Ra = /* @__PURE__ */ O(na, [["__scopeId", "data-v-ab06b7b0"]]), Ea = /* @__PURE__ */ g({
  __name: "Pill",
  props: {
    success: { type: Boolean },
    warning: { type: Boolean },
    danger: { type: Boolean }
  },
  setup(l) {
    const e = l, t = u(() => !e.success && !e.warning && !e.danger), i = u(() => ({
      "bg-gray-200/25 text-gray-800/60 border-gray-300/25": t.value,
      "bg-green-200/50 text-green-900 border-green-300/50": e.success,
      "bg-yellow-200/50 text-yellow-700 border-yellow-300/75": e.warning,
      "bg-red-200/50 text-red-700 border-red-300/25": e.danger
    }));
    return (a, o) => (s(), c("div", {
      class: z(["w-fit font-secondary font-medium text-[12px] leading-[12px] p-[4.5px] rounded-sm whitespace-nowrap border", i.value])
    }, [
      K(a.$slots, "default")
    ], 2));
  }
}), sa = {
  key: 0,
  class: "flex h-6 mb-2"
}, oa = {
  key: 0,
  class: "w-fit h-full px-2 flex items-center justify-center rounded-sm font-secondary font-medium text-[12px] leading-[16px] text-white bg-[#1AAE39]"
}, ca = { class: "w-full select-none relative bg-gray-200/50 border-2 border-transparent rounded-[30px]" }, ra = { class: "flex h-7" }, ha = ["onClick"], pa = /* @__PURE__ */ g({
  __name: "PillTabs",
  props: {
    modelValue: {},
    tabs: {}
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, i = e, a = y(null), o = y(0), p = (d) => {
      o.value = d, i("update:modelValue", t.tabs[d].value);
    }, n = u(() => t.tabs.map((d) => d.callout)), r = u(() => t.tabs.some((d) => !!d.callout));
    He(() => {
      o.value = t.tabs.findIndex((d) => d.value === t.modelValue);
    });
    const h = (d) => ({
      ...d === o.value && {
        "opacity-100!": !0
      },
      ...t.tabs[d].disabled && {
        "opacity-[30%]!": !0,
        "cursor-default": !0,
        "pointer-events-none": "true"
      }
    }), v = u(() => {
      if (!a.value?.[o.value]) return {};
      const _ = `${o.value * (100 / t.tabs.length)}%`;
      return {
        width: `${100 / t.tabs.length}%`,
        left: _
      };
    });
    return (d, _) => (s(), c("div", null, [
      r.value ? (s(), c("div", sa, [
        (s(!0), c(B, null, U(n.value, (I, x) => (s(), c("div", {
          key: x,
          class: "flex-1 flex items-center justify-center"
        }, [
          I ? (s(), c("div", oa, E(I), 1)) : D("", !0)
        ]))), 128))
      ])) : D("", !0),
      w("div", ca, [
        w("div", ra, [
          (s(!0), c(B, null, U(t.tabs, (I, x) => (s(), c("div", {
            key: I.value,
            class: z(["flex-1 flex items-center justify-center font-primary font-medium text-gray-800 text-[14px] leading-[22px] opacity-60 cursor-pointer z-10 px-2", h(x)]),
            ref_for: !0,
            ref_key: "tabsRef",
            ref: a,
            onClick: (C) => p(x)
          }, E(I.label), 11, ha))), 128))
        ]),
        w("div", {
          class: "h-[28px] absolute rounded-[30px] transition-all bottom-0 bg-white z-0",
          style: q(v.value)
        }, null, 4)
      ])
    ]));
  }
}), Va = /* @__PURE__ */ O(pa, [["__scopeId", "data-v-462f1956"]]), da = {
  key: 0,
  class: "size-[9px] rounded-full bg-white"
}, Ba = /* @__PURE__ */ g({
  __name: "Radio",
  props: {
    modelValue: {},
    value: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, i = e, a = u(() => t.modelValue === t.value), o = () => {
      i("update:modelValue", t.value);
    }, p = u(() => ({
      "pointer-events-none": t.disabled
    })), n = u(() => ({
      ...a.value && {
        "bg-green-900 border-transparent": !0,
        "bg-gray-500/45!": t.disabled
      },
      ...!a.value && {
        "bg-gray-200/15": t.disabled
      },
      "group-hover:bg-gray-200/10 group-hover:border-gray-300/50": !a.value
    })), r = u(() => ({
      "text-gray-500/50!": t.disabled
    }));
    return (h, v) => (s(), c("div", {
      class: z(["group w-fit flex items-center cursor-pointer select-none", p.value]),
      onClick: o
    }, [
      w("div", {
        class: z(["size-5 border border-gray-200/75 rounded-full flex items-center justify-center", n.value])
      }, [
        a.value ? (s(), c("div", da)) : D("", !0)
      ], 2),
      h.$slots.default ? (s(), c("div", {
        key: 0,
        class: z(["ml-2.5 font-secondary text-[14px] leading-[18px] text-gray-800", r.value])
      }, [
        K(h.$slots, "default")
      ], 2)) : D("", !0)
    ], 2));
  }
}), va = ["id", "value"], ua = ["for"], _a = {
  key: 0,
  class: "flex font-secondary text-[12px] leading-[16px] text-red-500 mt-[5px]"
}, Ha = /* @__PURE__ */ g({
  __name: "UiTextarea",
  props: {
    label: {},
    modelValue: {},
    errorMsg: {},
    disabled: { type: Boolean },
    class: {},
    onSubmit: { type: Function }
  },
  emits: ["update:modelValue", "focus", "submit"],
  setup(l, { emit: e }) {
    const t = l, i = e, a = y(null), o = u(() => t.label.toLowerCase().replace(/\W+/g, " ").trim().replace(/\s/g, "-")), p = u(() => ({
      "pointer-events-none bg-gray-200/15! tablet-h:bg-gray-200/10! text-gray-500/40!": t.disabled,
      "border-red-500!": t.errorMsg,
      "tablet-h:focus:outline-solid tablet-h:focus:outline-2 tablet-h:focus:outline-green-200/50 tablet-h:focus:border-green-500": !t.errorMsg,
      ...t.class && t.class.split(" ").reduce(
        (v, d) => (v[d] = !0, v),
        {}
      )
    })), n = u(() => ({
      "peer-placeholder-shown:text-gray-500/40! text-gray-500/30! peer-focus:text-gray-500/30!": t.disabled
    })), r = () => {
      t.disabled || (a.value?.focus(), i("focus"));
    }, h = (v) => {
      i("update:modelValue", v.target.value);
    };
    return N(
      () => t.disabled,
      () => {
        t.disabled && a.value?.blur();
      }
    ), L(() => {
      const v = setInterval(() => {
        document.querySelector(`#${o.value}:-webkit-autofill`) && (r(), a.value?.blur(), clearInterval(v));
      }, 50);
      setTimeout(() => {
        clearInterval(v);
      }, 1e3);
    }), (v, d) => (s(), c(B, null, [
      w("div", {
        class: "relative text-[14px] leading-[18px]",
        onClick: r
      }, [
        w("textarea", {
          id: o.value,
          placeholder: " ",
          ref_key: "input",
          ref: a,
          class: z(["resize-none font-primary peer appearance-none w-full h-[130px] pt-[22px] px-[17px] pb-2 bg-gray-200/25 tablet-h:bg-transparent rounded-md text-gray-800 outline-hidden border border-transparent tablet-h:border-gray-200/75 tablet-h:hover:border-gray-300/50", p.value]),
          value: t.modelValue,
          onFocus: r,
          onInput: h,
          onChange: h
        }, null, 42, va),
        w("label", {
          for: o.value,
          class: z(["font-primary pointer-events-none transition-all text-gray-500/70 absolute left-[18px] top-[5px] origin-[0] peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-2.5 translate-y-0 peer-focus:translate-y-0 peer-placeholder-shown:text-[14px] peer-placeholder-shown:font-[400] font-medium peer-focus:font-medium", n.value])
        }, E(t.label), 11, ua)
      ]),
      t.errorMsg ? (s(), c("div", _a, [
        $(H, {
          size: 14,
          name: "Alert",
          class: "mr-[5px] stroke-red-500 mt-px"
        }),
        Q(" " + E(l.errorMsg), 1)
      ])) : D("", !0)
    ], 64));
  }
}), ga = { class: "mt-[-1px]" }, $a = /* @__PURE__ */ g({
  __name: "Message",
  props: {
    type: { default: "default" },
    contentFullWidth: { type: Boolean, default: !0 },
    icon: {}
  },
  setup(l) {
    const e = l, t = u(() => ({
      "bg-[#F4F5F7] text-gray-600": e.type === "default",
      "bg-[#DFF2F4] text-green-900": e.type === "success",
      "bg-[#FCF8DB] text-yellow-700": e.type === "warning",
      "bg-[#F4E1E1] text-red-700": e.type === "error"
    })), i = u(() => {
      if (e.icon !== "none")
        return e.type === "error" || e.type === "warning" ? "Alert" : e.type === "success" ? "CircleCheck" : e.icon;
    }), a = u(() => ({
      "stroke-gray-600": e.type === "default",
      "stroke-green-900": e.type === "success",
      "stroke-yellow-700": e.type === "warning",
      "stroke-red-700": e.type === "error"
    }));
    return (o, p) => (s(), c("div", {
      class: z(["w-full font-secondary text-[14px] leading-[20px] px-[14.5px] py-2.5 rounded-md flex items-start", t.value])
    }, [
      i.value ? (s(), Z(H, {
        key: 0,
        size: 18,
        name: i.value,
        class: z(["mr-[14px]", a.value])
      }, null, 8, ["name", "class"])) : D("", !0),
      w("div", ga, [
        K(o.$slots, "default")
      ])
    ], 2));
  }
}), se = 4, fa = ({
  path: l,
  componentRef: e,
  containerRef: t
}) => {
  const i = y(0), a = y(0), o = y(0), p = y(0), n = l.length > se ? l.length - se : 0, r = y(n), h = () => {
    a.value = i.value || 0, i.value = t.value?.clientWidth || 0, o.value = e.value?.clientWidth || 0, v();
  }, v = async () => {
    const x = p.value;
    p.value = document.body.clientWidth;
    const C = x !== 0 && x < p.value, f = x === 0 || x >= p.value;
    if (C) {
      if (a.value > i.value)
        return await d();
      const V = document.createElement("div");
      V.textContent = l[r.value - 1];
      const T = e.value?.cloneNode(
        !0
      );
      T.classList.add("invisible", "absolute", "top-[-100%]"), T.appendChild(V), t.value?.appendChild(T), T.clientWidth < i.value && (r.value = Math.max(
        --r.value,
        n
      )), T.remove();
    }
    if (f) {
      if (a.value < i.value)
        return await d();
      if (o.value >= i.value) {
        const V = ++r.value;
        r.value = Math.min(
          V,
          l.length - 1
        );
      }
    }
  };
  L(async () => {
    await d(), window.addEventListener("resize", h);
  }), $e(() => {
    window.removeEventListener("resize", h);
  });
  const d = async () => {
    r.value = n;
    for (const x of l)
      h(), await Fe();
  }, _ = u(
    () => l.slice(r.value)
  ), I = u(
    () => l.slice(0, r.value)
  );
  return {
    visibleLocations: _,
    hiddenLocations: I
  };
}, ya = {
  key: 0,
  class: "flex items-center mr-1"
}, ma = ["onClick"], xa = {
  key: 0,
  class: "mx-1 opacity-60"
}, Fa = /* @__PURE__ */ g({
  __name: "Breadcrumb",
  props: {
    path: {},
    iconSize: {},
    dropdownPosition: {},
    activeLocationClass: { default: "last:font-variable last:font-[550] last:[font-stretch:20%]" }
  },
  emits: ["location"],
  setup(l, { emit: e }) {
    const t = l, i = e, a = y(null), o = y(null), { visibleLocations: p, hiddenLocations: n } = fa({
      path: t.path,
      containerRef: a,
      componentRef: o
    }), r = u(() => ({
      minWidth: `${t.iconSize + 8}px`,
      maxWidth: `${t.iconSize + 8}px`,
      minHeight: `${t.iconSize + 8}px`,
      maxHeight: `${t.iconSize + 8}px`
    })), h = (d) => d !== p.value.length - 1, v = async (d) => {
      d === 0 ? i("location", t.path.slice(0, 1)) : i("location", t.path.slice(0, d + 1));
    };
    return (d, _) => (s(), c("div", {
      class: "w-full select-none",
      ref_key: "container",
      ref: a
    }, [
      w("div", {
        class: "w-fit h-[30px] font-secondary text-gray-800 flex items-center whitespace-nowrap",
        ref_key: "component",
        ref: o
      }, [
        F(n).length ? (s(), c("div", ya, [
          $(F(oe), { anchor: "left" }, {
            default: j(() => [
              $(F(ce), null, {
                default: j(() => [
                  w("div", {
                    class: "cursor-pointer mr-1 hover:bg-gray-800/6 rounded-[2px] flex items-center justify-center",
                    style: q(r.value)
                  }, [
                    $(H, {
                      name: "ThreeDots",
                      size: t.iconSize,
                      class: "fill-gray-800 stroke-gray-800"
                    }, null, 8, ["size"])
                  ], 4)
                ]),
                _: 1
              }),
              $(F(re), null, {
                default: j(() => [
                  $(F(ue), { class: "w-fit! max-w-[280px]" }, {
                    default: j(() => [
                      (s(!0), c(B, null, U(F(n), (I, x) => (s(), Z(F(_e), {
                        key: x,
                        onClick: (C) => v(x)
                      }, {
                        default: j(() => [
                          Q(E(I), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _[0] || (_[0] = w("div", { class: "no-select" }, "/", -1))
        ])) : D("", !0),
        (s(!0), c(B, null, U(F(p), (I, x) => (s(), c(B, { key: x }, [
          w("div", {
            class: z(`cursor-pointer last:cursor-default hover:underline last:hover:no-underline opacity-60 last:opacity-100 ${t.activeLocationClass}`),
            onClick: (C) => v(x + F(n).length)
          }, E(I), 11, ma),
          h(x) ? (s(), c("div", xa, "/")) : D("", !0)
        ], 64))), 128))
      ], 512)
    ], 512));
  }
}), Ia = { class: "w-full min-h-[42px] relative" }, Pa = { class: "flex gap-x-[14px] overflow-x-auto overflow-y-hidden relative" }, Ma = ["onClick"], ba = /* @__PURE__ */ g({
  __name: "Tabs",
  props: {
    modelValue: {},
    tabs: {}
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, i = e, a = y(), o = y(!1), p = (h) => ({
      "text-gray-800! font-semibold": h.value === t.modelValue
    }), n = u(() => {
      const h = t.tabs.findIndex(
        (_) => _.value === t.modelValue
      ), v = a.value?.[h].clientWidth, d = a.value?.[h].offsetLeft;
      return {
        width: `${v}px`,
        left: `${d}px`
      };
    }), r = (h) => {
      i("update:modelValue", h.value);
      const v = t.tabs.findIndex((d) => d.value === h.value);
      a.value?.[v].scrollIntoView({ block: "nearest", inline: "nearest" });
    };
    return L(() => {
      setTimeout(() => {
        o.value = !0;
      }, 100);
    }), (h, v) => (s(), c("div", Ia, [
      w("div", Pa, [
        (s(!0), c(B, null, U(t.tabs, (d) => (s(), c("div", {
          key: d.value,
          class: z(["cursor-pointer px-[7px] h-[42px] font-primary font-medium text-[14px] leading-[26px] text-gray-800/75 whitespace-nowrap", p(d)]),
          ref_for: !0,
          ref_key: "tabEl",
          ref: a,
          onClick: (_) => r(d)
        }, E(d.label), 11, Ma))), 128)),
        o.value ? (s(), c("div", {
          key: 0,
          class: "h-1 bg-green-900 transition-all absolute bottom-0 z-10",
          style: q(n.value)
        }, null, 4)) : D("", !0)
      ]),
      v[0] || (v[0] = w("div", { class: "w-full h-px bg-[#DFDFDF] absolute left-0 bottom-0 right-0" }, null, -1))
    ]));
  }
}), Ua = /* @__PURE__ */ O(ba, [["__scopeId", "data-v-e9b1e1a3"]]), qa = { Base: oe, Trigger: ce, Component: re }, Ta = {
  Base: Ue,
  Title: qe,
  Content: Te,
  Separator: We
}, Wa = {
  Base: je,
  HeaderCheckbox: Oe,
  Headers: Ze,
  Header: Ge,
  Row: Ne,
  Cell: Qe,
  CheckboxCell: Ke,
  useTable: Le
}, La = {
  Base: ue,
  Item: _e,
  Separator: Ye
}, ja = {
  Base: Xe,
  Item: Je,
  Input: et,
  Result: tt
}, Oa = {
  Base: at,
  Item: it,
  Header: nt,
  Content: st
};
export {
  Oa as Accordion,
  Da as Avatar,
  Fa as Breadcrumb,
  Ra as Calendar,
  Ta as Card,
  Na as Checkbox,
  ja as Combobox,
  qa as Float,
  H as Icon,
  La as Menu,
  $a as Message,
  Ea as Pill,
  Va as PillTabs,
  Ba as Radio,
  yt as Skeleton,
  Wa as Table,
  Ua as Tabs,
  Ca as ThumbnailIcon,
  za as Toggle,
  Sa as UiButton,
  ka as UiInput,
  Ha as UiTextarea
};
